{
  "USD": "USD",
  "GBP": "GBP",
  "EUR": "EUR",
  "AUD": "AUD",
  "general": {
    "login": "Connexion",
    "email-address": "Adresse e-mail",
    "failed": "Échec",
    "processing": "En cours",
    "app-loading": "Chargement de l'application",
    "loading": "Chargement",
    "team-members": "membres",
    "spaces-available": "places disponibles",
    "AM": "AM",
    "PM": "PM",
    "am-only": "AM uniquement",
    "pm-only": "PM uniquement",
    "add": "Ajouter",
    "desks-available": "Bureaux disponibles",
    "successfully-logged-out": "Déconnexion réussie",
    "admin": "(Admin)",
    "no-team": "Aucune équipe",
    "or": "Ou",
    "no-department": "-- Aucun département --",
    "select-department": "-- Sélectionner un département --",
    "all-teams": "Toutes les équipes",
    "select-team": "-- Sélectionner une équipe --",
    "first-monday": "Premier lundi en",
    "first-day": "Premier jour en",
    "name": "Nom",
    "full-name": "Nom complet",
    "how-it-works": "Comment ça marche",
    "description": "Description"
  },
  "errors": {
    "email-in-use": {
      "title": "Cette adresse e-mail est déjà utilisée.",
      "message": "Si vous êtes déjà inscrit mais souhaitez passer à Google ou Microsoft, contactez <0>hello@team-today.com</0> et nous pourrons migrer votre compte."
    },
    "email-exists": {
      "message": "Essayez de <0>vous connecter</0> ou contactez-nous à <1>hello@team-today.com</1> et nous pourrons vous aider.",
      "logging-in": "vous connecter"
    },
    "company-already-registered": {
      "title": "Votre entreprise possède déjà un compte.",
      "message": "Demandez une invitation à un autre utilisateur de votre entreprise. Si vous avez déjà un compte, essayez de <0>vous connecter</0>.",
      "logging-in": "vous connecter"
    },
    "general": {
      "title": "Une erreur s'est produite lors de votre inscription.",
      "message": "Réessayez, si le problème persiste, contactez <0>hello@team-today.com</0> et nous pourrons vous aider."
    },
    "no-account-registered": {
      "title": "Une erreur s'est produite lors de votre inscription.",
      "message": "Vous pouvez créer un compte ou demander une invitation à un collègue. Si vous pensez déjà avoir un compte, veuillez contacter <0>support@team-today.com</0>.",
      "button": "Créer un nouveau compte"
    },
    "azure": {
      "consent-message": {
        "message-1": "Pour que Team Today fonctionne avec <strong>Microsoft 365</strong>, nous avons besoin de l'autorisation d'accéder en toute sécurité à vos <strong>paramètres de calendrier et de messagerie</strong>.",
        "message-2": "Veuillez cocher les cases pour les autorisations et cliquer sur accepter."
      },
      "access-denied": {
        "message-1": "Pour que Team Today fonctionne avec <strong>Microsoft 365</strong>, nous avons besoin de l'autorisation d'accéder en toute sécurité à vos <strong>paramètres de calendrier et de messagerie</strong>.",
        "message-2": "Vous pouvez demander l'accès à team-today.com auprès de <strong>votre service informatique</strong> ou contacter <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> pour plus de conseils et d'aide."
      },
      "not-access-den-and-not-consent": {
        "message-1": "Quelque chose d'inattendu s'est produit.",
        "message-2": "Nous avons enregistré le problème, vous pouvez essayer de vous reconnecter et si vous rencontrez toujours des problèmes, envoyez-nous un message à <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> et nous vous contacterons dès que possible."
      }
    }
  },
  "login": {
    "title": "Connectez-vous à votre compte",
    "valid-email-address-error": "Veuillez entrer une adresse e-mail valide",
    "enter-password": "Veuillez entrer un mot de passe",
    "signup-with-microsoft": "Inscription sécurisée avec",
    "sync-own-calendars": "pour synchroniser facilement vos calendriers.",
    "with-google": "Se connecter avec Google",
    "with-office365": "Se connecter avec Microsoft 365",
    "or-login-with-email": "Ou se connecter avec e-mail",
    "email-address": "Adresse e-mail",
    "password": "Mot de passe",
    "repeat-password": "Répéter le mot de passe",
    "remember": "Se souvenir de moi",
    "login": "Connexion",
    "no-account": "Vous n'avez pas de compte ?",
    "have-an-account": "Vous avez déjà un compte ?",
    "microsoft": "Microsoft",
    "microsoft-or-google": "Microsoft ou Google",
    "email-sent": "Nous vous avons envoyé un e-mail",
    "email-validated": "Votre e-mail a été validé, connectez-vous maintenant à Team Today pour commencer à l'utiliser.",
    "email-validation-failed": "Essayez de demander à nouveau l'e-mail de validation.",
    "terms-link": {
      "1": "J'accepte les",
      "2": "Conditions générales",
      "3": "et la",
      "4": "Politique de confidentialité"
    },
    "marketing-emails": "Tenez-moi informé des dernières nouvelles et contenus de Team Today",
    "login-failed-with-azure": "Quelque chose s'est mal passé lors de la récupération de votre compte Microsoft, veuillez réessayer.",
    "login-failed-with-azure-help": "Si le problème persiste, contactez-nous à <0>hello@team-today.com</0> et nous vous aiderons.",
    "create-account-with-own-password": "Créez un compte avec votre propre mot de passe. Ce compte ne sera pas synchronisé avec Microsoft 365 ou Google.",
    "company-already-has-account": "Votre entreprise a déjà un compte. Vous pouvez continuer directement avec votre connexion Microsoft 365.",
    "try-another-method": "Ou cliquez ici pour utiliser une autre méthode",
    "not-registered": "Le compte {{email}} n'est pas enregistré sur Team Today.",
    "not-registered-no-email": "Votre compte Microsoft n'est pas enregistré sur Team Today.",
    "not-registered-help": "Si votre entreprise utilise déjà Team Today, demandez à un collègue ou à un administrateur informatique une invitation, sinon créez un nouveau compte.",
    "not-registered-assistance": "Si vous avez besoin d'aide, contactez-nous à <0>hello@team-today.com</0>."
  },
  "register": {
    "title": "Inscription",
    "best-experience-signup": "Pour la meilleure expérience, inscrivez-vous en toute sécurité avec <strong>Microsoft</strong> ou <strong>Google</strong> pour synchroniser facilement Team Today avec votre calendrier professionnel.",
    "office365": "S'inscrire avec Microsoft 365",
    "google": "S'inscrire avec Google",
    "email": "S'inscrire avec e-mail",
    "follow-the-link": "Suivez le lien pour compléter votre inscription.",
    "review-terms": "Consultez les conditions pour vous inscrire",
    "terms-accept-message": "J'accepte les <0>Conditions générales</0> et la <1>Politique de confidentialité</1>*",
    "best-experience-use-ms": "Pour la meilleure expérience, nous recommandons de vous inscrire en toute sécurité avec <strong>Microsoft</strong> pour synchroniser facilement Team Today avec votre calendrier professionnel.",
    "create-account-with-password": "Créer un compte avec mot de passe",
    "register-tnc": "J'accepte les <a href=\"https://team-today.com/legal/terms-and-conditions\">Conditions générales</a> et la <a href=\"https://team-today.com/legal/privacy-policy\">Politique de confidentialité</a>*",
    "verification-required": "Nous devons vérifier votre e-mail",
    "check-inbox": "Vérifiez votre boîte de réception",
    "follow-link": "Suivez le lien pour compléter votre inscription",
    "resend-email": "Renvoyer l'e-mail ?"
  },
  "teams-register": {
    "title": "La manière la plus simple de <strong>gérer et planifier le travail hybride</strong>",
    "create-account": "Ou <0>créer un compte avec e-mail</0> et mot de passe",
    "have-account": "Vous avez déjà un compte ? <0>Connectez-vous</0>",
    "list-item-1": "Gérez <strong>les déplacements de l'équipe</strong>",
    "list-item-2": "Réservez <strong>des bureaux</strong> et gérez <strong>les espaces de travail</strong>",
    "list-item-3": "Planifiez les congés et <strong>les vacances</strong>",
    "started": "Commencez gratuitement",
    "": ""
  },
  "forgot-password": {
    "forgot-password": "Mot de passe oublié",
    "description": "Entrez votre adresse e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe",
    "send-password": "Envoyer la réinitialisation du mot de passe",
    "request-processing": "Votre demande de réinitialisation de mot de passe est en cours de traitement.",
    "follow-link": "Suivez le lien pour réinitialiser votre mot de passe.",
    "enter-email-address": "Entrez votre adresse e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe",
    "send-password-reset": "Envoyer la réinitialisation du mot de passe",
    "your-email-address": "Votre adresse e-mail"
  },
  "reset-password": {
    "stale-token": "Ce jeton a expiré. Demandez un nouvel e-mail",
    "success": "Succès ! Allez à la page de connexion pour vous connecter",
    "forgot-password": "Mot de passe oublié",
    "go-to-login": "Aller à la connexion",
    "try-requesting-new-email-reset": "Essayez de demander un nouvel e-mail de réinitialisation",
    "request-new-email-reset": "Demander un nouvel e-mail de réinitialisation",
    "new-pass": "Nouveau mot de passe",
    "repeat-new-pass": "Répéter le nouveau mot de passe",
    "reset-pass": "Réinitialiser le mot de passe",
    "reset-pass-to-login": "Réinitialisez votre mot de passe pour vous permettre de vous connecter",
    "passwords-not-match": "Les mots de passe ne correspondent pas",
    "passwords-not-blank": "Le mot de passe ne doit pas être vide"
  },
  "invite": {
    "title": "Compléter l'inscription",
    "passwords-mismatch": "Les mots de passe ne correspondent pas",
    "failed": "Les mots de passe ne correspondent pas",
    "register-failed": "L'inscription avec invitation a échoué",
    "tandc": "Veuillez accepter les conditions générales avant de continuer.",
    "issues": "Vous rencontrez toujours des problèmes ? Envoyez-nous un e-mail à <a href=\"mailto:hello@team-today.com\">hello@team-today.com</a> et nous vous répondrons dès que possible.",
    "create-account-with-password": "Ou <0>créer un compte avec mot de passe</0>"
  },
  "team-view": {
    "team-view": "Vue d'équipe",
    "whereabouts": "Déplacements",
    "edit-whereabouts": "Modifier les déplacements",
    "set-whereabouts": "Définir les déplacements",
    "teams": "Équipes",
    "offices": "Bureaux",
    "workgroup": "Groupe de travail",
    "departments": "Départements",
    "misc": "Divers",
    "whereabouts-report": "Mon rapport de localisation"
  },
  "settings": {
    "settings": "Paramètres",
    "bookable-areas": "Zones réservables",
    "button-add-team-member": "Ajouter un nouveau membre d'équipe",
    "button-add-user": "Ajouter un utilisateur",
    "edit-office": "Modifier le bureau",
    "create-new-office": "Créer un nouveau bureau",
    "edit-past-whereabouts-title": "Empêcher les utilisateurs de modifier les déplacements passés",
    "edit-past-whereabouts-enabled-description": "Ce paramètre permet uniquement aux administrateurs de l'entreprise et aux administrateurs de bureau de modifier les déplacements des semaines précédentes.",
    "edit-past-whereabouts-disabled-description": "Les utilisateurs peuvent modifier leurs déplacements passés",
    "edit-past-whereabouts-recommendation": "Nous recommandons d'activer cette option si les approbations sont activées ou si Team Today est utilisé pour surveiller les absences.",
    "manage-teams-and-users": "Gérer les équipes et les utilisateurs",
    "users-with-no-teams": "Utilisateurs sans équipe",
    "my-team": "Mon équipe",
    "other-teams": "Autres équipes",
    "personal-pref": "Préférences personnelles",
    "personal-pref-desc": "Définir des rappels et synchroniser vos événements Team Today avec votre calendrier personnel",
    "email-reminder": "Rappel par e-mail",
    "email-reminder-desc": "Recevez un rappel hebdomadaire par e-mail pour définir vos déplacements pour la semaine à venir.",
    "calendar-link": "Ajouter des événements à votre calendrier professionnel",
    "languages": "Changer de langue",
    "calendar-link-tip": "Pour la meilleure expérience, nous vous recommandons de garder ce paramètre activé.",
    "calendar-link-desc": "Ajoutez des événements tels que des vacances et des déplacements de Team Today à vos calendriers <strong>Outlook</strong> ou <strong>Gmail</strong> pour que vos collègues puissent les voir.",
    "marketing-emails": "Autoriser les e-mails marketing",
    "marketing-emails-desc": "Recevez des e-mails annonçant nos dernières fonctionnalités et comment les utiliser.",
    "fav-office": "Vos bureaux préférés",
    "assigned-desk": "Attribué",
    "billing-header": "Paramètres de facturation et de plan",
    "payment-details": "Détails de paiement",
    "cancel-message": "Vos détails de paiement sont gérés par un gestionnaire de compte, pour les mettre à jour ou les modifier, contactez-nous à <strong><0>support@team-today.com</0></strong>",
    "account-usage": "Gérez votre forfait d'abonnement, vos licences et vos informations de facturation.",
    "users-registered": "Utilisateurs enregistrés",
    "spaces-left": "Places restantes",
    "teams-in-use": "Équipes utilisées",
    "teams-left": "Équipes restantes",
    "member-limit-reached": "Votre compte est maintenant plein",
    "account-full-in-teams": "Ce compte est maintenant plein, veuillez nous contacter à support@team-today.com",
    "account-full-normal": "Votre <strong>compte gratuit</strong> est maintenant <strong>plein</strong>. Pour ajouter plus de membres d'équipe, vous devrez passer à un compte payant.",
    "holiday-rules": "Règles de congés",
    "holiday-year-start-message": "Indiquez-nous quand commence votre année de congés.",
    "all-users-have-team": "Tous les utilisateurs ont une équipe !",
    "setup-a-company": "Configurer une entreprise",
    "company-name": "Nom de l'entreprise",
    "create-floor-plan": "Créer un plan d'étage",
    "create-floor-plan-description": "Avec un plan d'étage, vous pouvez réserver des bureaux spécifiques et voir où sont assis vos collègues.",
    "create-floor-plan-instructions": "Envoyez votre plan d'étage à <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0> et nous en créerons une version interactive pour votre équipe... GRATUITEMENT",
    "users-reporting-to-this-user": "Voici toutes les personnes qui relèvent directement de cet utilisateur.",
    "line-reports": "Rapports hiérarchiques",
    "indirect-line-reports": "Rapports hiérarchiques indirects",
    "no-line-reports": "Aucun rapport hiérarchique",
    "office-management": "Gestion des bureaux",
    "set-limits-on-offices": "Définissez une limite au nombre de bureaux disponibles pour que les collègues sachent quand venir au bureau.",
    "offices": "Bureaux",
    "office-floor": "Étage du bureau",
    "manage-office-locations-title": "Gérer les emplacements des bureaux",
    "manage-office-locations-description": "Créez et gérez plusieurs bureaux dans la zone de gestion des bureaux.",
    "assign-users": "Assigner des utilisateurs",
    "users-not-in-team": "Ces utilisateurs ne font actuellement partie d'aucune équipe. Cliquez sur l'un d'eux pour le déplacer dans une équipe.",
    "locked-signup-domains": {
      "title": "Domaines verrouillés",
      "subtitle": "Empêchez les personnes de votre entreprise de créer un compte Team Today séparé. Toute personne s'inscrivant avec l'un de ces domaines sera informée que votre entreprise possède déjà un compte et devra demander une invitation à un collègue. Les utilisateurs invités peuvent toujours rejoindre normalement.",
      "approval-note": "Les nouveaux domaines sont vérifiés par l'équipe Team Today avant d'être appliqués. Cela prend généralement un jour ouvré.",
      "placeholder": "ex. votreentreprise.com",
      "add": "Ajouter le domaine",
      "remove": "Supprimer",
      "empty": "Aucun domaine ajouté pour le moment.",
      "status-active": "Actif",
      "status-pending": "En attente d'approbation",
      "status-rejected": "Non approuvé",
      "rejected-help": "Nous n'avons pas pu confirmer que votre entreprise possède ce domaine. Contactez support@team-today.com si vous pensez qu'il s'agit d'une erreur.",
      "remove-confirm": "Supprimer {{domain}} ? Les personnes ayant ce domaine e-mail pourront à nouveau créer un nouveau compte.",
      "add-failed": "Impossible d'ajouter ce domaine.",
      "remove-failed": "Impossible de supprimer ce domaine."
    },
    "domain-based-signup": {
      "title": "Lier un nom de domaine",
      "subtitle": "Les individus peuvent s'inscrire eux-mêmes",
      "everyone": "Bon pour tout le monde",
      "enabled-message": "Toute personne s'inscrivant avec une adresse e-mail se terminant par <0>{{domainName}}</0> sera immédiatement ajoutée à votre compte. Informez-les simplement de Team Today et demandez-leur de créer un compte.",
      "enabled-message-multiple": "Toute personne s'inscrivant avec une adresse e-mail se terminant par l'un des domaines <0>{{domains}}</0> sera immédiatement ajoutée à votre compte. Informez-les simplement de Team Today et demandez-leur de créer un compte.",
      "disabled-message": "Toute personne s'inscrivant avec une adresse e-mail se terminant par <0>votre nom de domaine<0> sera immédiatement ajoutée à votre compte. Informez-les simplement de Team Today et demandez-leur de créer un compte.",
      "your-domain-name": "votre nom de domaine",
      "domains-title": "Domaines liés",
      "approval-note": "Ajoutez tous les domaines e-mail utilisés par votre entreprise. Chacun est vérifié par l'équipe Team Today avant de prendre effet, généralement sous un jour ouvré.",
      "placeholder": "ex. votreentreprise.fr",
      "add": "Ajouter un domaine",
      "remove": "Supprimer",
      "empty": "Aucun domaine lié pour le moment. Ajoutez le domaine e-mail de votre entreprise pour commencer.",
      "status-active": "Actif",
      "status-pending": "En attente d'approbation",
      "status-rejected": "Non approuvé",
      "rejected-help": "Nous n'avons pas pu confirmer que votre entreprise possède ce domaine. Contactez support@team-today.com si vous pensez qu'il s'agit d'une erreur.",
      "remove-confirm": "Supprimer {{domain}} ? Les personnes ayant ce domaine e-mail ne rejoindront plus votre compte automatiquement.",
      "add-failed": "Impossible d'ajouter ce domaine.",
      "remove-failed": "Impossible de supprimer ce domaine.",
      "switch-off-note": "Activez l'interrupteur ci-dessus pour que ces domaines prennent effet.",
      "pending-line-1": "Veuillez prévoir 24 heures pour ce paramètre",
      "pending-line-2": "Dans le cadre de notre processus de sécurité, nous examinons activement les demandes de liaison.",
      "pending-line-3": "Une fois approuvés, les nouveaux utilisateurs qui n'ont pas été invités devront être assignés à une équipe. Vous pouvez le faire dans les paramètres utilisateur.",
      "pending-line-4": "Vous pourrez toujours envoyer des invitations directes aux adresses e-mail qui ne se terminent pas par ce nom de domaine.",
      "active-line-1": "Juste pour information",
      "active-line-2": "Les nouveaux utilisateurs qui n'ont pas été invités devront être assignés à une équipe. Vous pouvez le faire dans les paramètres utilisateur.",
      "active-line-3": "Vous pourrez toujours envoyer des invitations directes aux adresses e-mail qui ne se terminent pas par ce nom de domaine."
    },
    "private-groups": {
      "title": "Restreindre la visibilité de tous les groupes",
      "subtitle": "Restreindre la visibilité de tous les départements, équipes et groupes. Seuls les administrateurs de l'entreprise et les administrateurs de bureau, ainsi que les utilisateurs des groupes, pourront voir les déplacements des autres utilisateurs."
    },
    "restrict-team-management": {
      "title": "Restreindre la gestion des équipes",
      "subtitle": "Restreindre la gestion des équipes aux administrateurs de l'entreprise. Cela inclut l'ajout de nouveaux utilisateurs, ainsi que le déplacement ou la suppression des utilisateurs existants."
    },
    "show-birthdays": {
      "title": "Afficher les anniversaires",
      "subtitle": "Si un utilisateur a défini le mois et le jour de son anniversaire, cela affichera les anniversaires des utilisateurs sous forme de petite icône sur leurs déplacements."
    },
    "azure-scim": {
      "medium": "Moyenne - Grandes entreprises (50 et plus)",
      "title": "Microsoft Azure et Team Today",
      "subtitle": "Importer des utilisateurs à partir d'Active Directory vers Team Today",
      "description": "Les administrateurs informatiques peuvent rechercher Team Today dans la place de marché Microsoft Azure. Cela automatisera les arrivées et départs dans Team Today à partir d'Active Directory et les placera dans des équipes, groupes de travail ou départements. Des instructions détaillées sont disponibles sur nos pages de support.",
      "line-1": "Juste pour information",
      "line-2": "Avec cette option activée, les utilisateurs nouvellement provisionnés recevront un e-mail de bienvenue et seront rappelés chaque semaine pour définir leurs déplacements.",
      "line-3": "Plus d'informations sur la configuration peuvent être trouvées sur <0 href=\"https://www.team-today.com\">Configuration SCIM</0>",
      "enabled-departments": "Provisionner les utilisateurs dans les départements",
      "enabled-departments-description": "Provisionner les utilisateurs et mettre à jour leur département en fonction de leur attribut de département dans Azure AD.",
      "disable-welcome-email": "Envoyer un e-mail de bienvenue aux utilisateurs nouvellement provisionnés",
      "disable-welcome-email-description": "Une fois la configuration initiale d'Azure et les tests terminés, nous recommandons d'activer ce paramètre pour envoyer des e-mails de bienvenue aux nouveaux utilisateurs.",
      "disable-new-user-access": "Autoriser l'accès à Team Today pour les utilisateurs nouvellement provisionnés",
      "disable-new-user-access-description": "Une fois la configuration initiale d'Azure et les tests terminés, nous recommandons d'activer ce paramètre pour accorder l'accès à Team Today aux nouveaux utilisateurs.",
      "scim-integration": "Paramètres d'intégration SCIM",
      "enabled-departments-description-2": "L'activation empêchera la gestion des départements dans Team Today car les mises à jour proviendront de SCIM."
    },
    "spreadsheet": {
      "trial": "Entreprises en essai gratuit",
      "title": "Importer une feuille de calcul",
      "subtitle": "Si vous ne souhaitez pas encore connecter Azure ou si vous avez moins de 50 personnes",
      "description": "Contactez support@team-today.com et nous vous fournirons un modèle à compléter, puis renvoyez-le et nous ferons le reste."
    },
    "holiday-approval": {
      "title": "Notifications d'approbation",
      "message": "Cela enverra un e-mail aux responsables hiérarchiques concernés lorsqu'un congé est réservé, les invitant à aller sur Team Today pour examiner la demande de congé."
    },
    "holiday-tracking": {
      "title": "Activer le suivi des congés",
      "message": "Cela activera le paramètre de suivi des congés pour que les collègues puissent rapidement voir quand les congés sont planifiés dans leur équipe et d'autres."
    },
    "line-management": {
      "title": "Activer les responsables hiérarchiques",
      "enabled-message": "Cela vous permettra d'assigner des rapports hiérarchiques aux utilisateurs. Ces responsables pourront approuver les demandes faites par leurs rapports hiérarchiques. Allez dans <0 to={\"/manage/users?view=user\"}>Vue utilisateur</0> pour rechercher des utilisateurs et leur assigner des rapports hiérarchiques.",
      "disabled-message": "Cela activera le paramètre des responsables hiérarchiques pour que vous puissiez assigner des rapports hiérarchiques aux utilisateurs. Ces responsables pourront approuver les demandes faites par leurs rapports hiérarchiques."
    },
    "seven-day": {
      "title": "Activer la semaine de sept jours",
      "enabled-message": "Cela permettra aux utilisateurs de compléter leurs déplacements le week-end.",
      "disabled-message": "Cela permettra aux utilisateurs de compléter leurs déplacements le week-end."
    },
    "weekly-notes": {
      "title": "Activer les notes hebdomadaires",
      "enabled-message": "Notes hebdomadaires activées, les utilisateurs peuvent les définir depuis la page des déplacements de l'équipe.",
      "disabled-message": "Cela activera les notes hebdomadaires - un champ de texte libre que les utilisateurs peuvent remplir avec une brève description que les collègues peuvent voir concernant leur semaine."
    },
    "global-email-setting": {
      "title": "Rappels par e-mail pour compléter les déplacements",
      "all-users": "Rappels envoyés à tous les utilisateurs hebdomadairement si incomplets",
      "no-users": "Ne pas envoyer de rappels",
      "users-choice": "Permettre aux individus de contrôler leurs propres rappels",
      "description": "Choisissez comment les rappels sont envoyés. Les rappels sont envoyés si un utilisateur n'a pas complété les déplacements de la semaine à venir."
    },
    "icon-pack": {
      "title": "Iconographie de Team Today",
      "description": "Vous pouvez changer l'apparence et le style des icônes utilisées dans Team Today",
      "standard": "Standard",
      "basic": "Professionnel"
    },
    "tenant-based": {
      "title": "Inscription basée sur le locataire",
      "message-1": "Cela associera votre ID de locataire Microsoft à ce compte. Toute personne qui s'inscrira sera automatiquement ajoutée à ce compte.",
      "message-2": "Vous pourrez toujours inviter manuellement des personnes extérieures à votre compte Microsoft à vous rejoindre.",
      "active-1": "Juste pour information",
      "active-2": "Les nouveaux utilisateurs qui n'ont pas été invités devront être assignés à une équipe. Vous pouvez le faire dans les paramètres utilisateur.",
      "active-3": "Vous pourrez toujours envoyer des invitations directes aux adresses e-mail qui ne se terminent pas par ce nom de domaine."
    },
    "hot-desking-page": {
      "title": "Bureaux partagés avancés",
      "message-1": "Dans le cadre d'un plan payant, vous pouvez",
      "message-2": "Créer plusieurs bureaux",
      "message-3": "Créer des étages et des zones de bureau pour que les équipes réservent",
      "message-4": "Tout lier à vos calendriers Outlook ou Gmail",
      "button": "Activer les bureaux partagés avancés"
    },
    "editing-future-whereabouts": {
      "repeat-weekly-schedule": "Planifications de déplacements",
      "repeat-weekly-schedule-description": "Combien de semaines à l'avance un utilisateur peut-il automatiquement définir ses déplacements. Nous recommandons 52 semaines.",
      "schedules": "Permettre aux utilisateurs de définir automatiquement leurs déplacements pour plusieurs semaines à l'avance",
      "number-of-weeks": "Limite de déplacements avancés (en semaines)",
      "applies-to-team-admins": "S'applique aux administrateurs d'équipe",
      "applies-to-standard-users": "S'applique aux utilisateurs standard",
      "number-of-weeks-description": "Le nombre de semaines que les utilisateurs peuvent définir à l'avance pour leurs déplacements"
    },
    "approvals": {
      "title": "Approbations",
      "do-holidays-require-approval": "Les congés nécessitent-ils l'approbation d'un responsable hiérarchique ou d'un administrateur de l'entreprise ?",
      "how-it-works": "Comment ça marche",
      "create-line-managers-message-1": "Créez des responsables hiérarchiques en ajoutant des rapports directs pour chaque utilisateur dans la page des paramètres individuels. (Appuyez sur l'utilisateur que vous souhaitez modifier)",
      "create-line-managers-message-2": "Ensuite, lorsque les rapports réservent des congés ou des vacances, le responsable hiérarchique sera invité à approuver la demande.",
      "create-line-managers-message-3": "Les administrateurs de l'entreprise peuvent approuver toutes les demandes.",
      "please-note": "Veuillez noter",
      "please-note-message-1": "Pour le moment, seuls les <strong>administrateurs de l'entreprise</strong> peuvent approuver ou rejeter les demandes de congé.",
      "company-admins": "administrateurs de l'entreprise",
      "please-note-message-2": "Les responsables hiérarchiques peuvent également le faire, mais vous devez activer le paramètre 'Responsables hiérarchiques' dans la page des paramètres de l'entreprise, puis assigner des rapports hiérarchiques à chaque utilisateur.",
      "approvals-disabled-title": "Approbations de congés inactives",
      "approvals-disabled-description": "Vous pouvez activer les approbations de congés pour les responsables dans la zone des paramètres principaux."
    },
    "holiday-allowance": {
      "title": "Quota de congés",
      "message-1": "Définissez une limite au nombre de jours que chaque personne peut prendre.",
      "please-note": "Veuillez noter",
      "message-2": "Les utilisateurs auront tous {{defaultHolidayCount}} jours de congés jusqu'à ce qu'ils soient définis par un administrateur de l'entreprise ou un responsable hiérarchique dans la page des paramètres de chaque utilisateur.",
      "zero": "zéro",
      "edit-individual-allowances": "Modifier les quotas individuels de congés"
    },
    "holiday-setting": {
      "year": "Année de congés",
      "month": "La période de l'année où votre période de congés commence et se termine."
    },
    "manage-area": {
      "create-area": "Créer une zone réservable",
      "name": "Nom de la zone",
      "message-1": "Cela créera des espaces que plusieurs utilisateurs peuvent réserver.",
      "message-2": "Rend la réservation de bureau plus rapide",
      "number-of-desks": "Nombre de bureaux"
    },
    "manage-desk": {
      "create-desk": "Créer des bureaux individuels réservables",
      "message-1": "Idéal pour les individus qui s'assoient toujours au même bureau",
      "message-2": "",
      "number-of-desks": "Nombre de bureaux",
      "floor-plans-enabled": "Il semble que vous ayez activé des plans d'étage interactifs",
      "contact-us-to-change": "Vous pouvez toujours ajouter un nouveau bureau à l'étage, mais contactez-nous à <0 href=\"mailto:hello@team-today.com\">hello@team-today.com</0> pour l'ajouter au plan d'étage interactif.",
      "desk-name": "Nom du bureau"
    },
    "visitor-booking": {
      "title": "Activer la réservation de visiteurs (Bêta)",
      "heading": "Gestion des visiteurs",
      "upsell": "La réservation de visiteurs est disponible avec les forfaits Premium et Enterprise.",
      "upsell-link": "Mettre à niveau votre forfait",
      "not-enabled": "Cette fonctionnalité n'est pas activée sur votre compte. Contactez"
    },
    "manage-office": {
      "title": "Créer un étage de bureau ?",
      "message": "Divisez votre bureau en étages pour aider vos collègues à savoir où s'asseoir",
      "another-floor": "Ajouter un autre étage",
      "additional-access-required": "Accès supplémentaire requis",
      "company-admin-only": "Seul un administrateur de l'entreprise peut créer de nouveaux bureaux/étages/zones/bureaux",
      "nosetup": "Vous n'avez rien configuré pour le moment, commencez par ajouter un bureau.",
      "no-setup-message-1": "Créez des <strong>étages</strong> et des <strong>zones de bureau</strong> pour que les équipes réservent",
      "no-setup-message-2": "Créez plusieurs bureaux",
      "no-setup-message-3": "Liez tout à vos calendriers <strong>Outlook</strong> ou <strong>Gmail</strong>",
      "enable-car-parking": "Activer la réservation de parking",
      "car-parking-capacity": "Nombre de places de parking",
      "desk-booking-window-title": "Activer la fenêtre de réservation de bureau",
      "desk-booking-window-description": "Empêcher les utilisateurs de réserver des bureaux trop longtemps à l'avance",
      "desk-booking-window-weeks": "Nombre de semaines à l'avance que les utilisateurs peuvent réserver"
    },
    "meeting-rooms": {
      "manage-meeting-rooms": "Gérer les salles de réunion",
      "add-meeting-rooms": "Ajouter des salles de réunion",
      "create": "Ajouter une salle de réunion",
      "name": "Nom de la salle de réunion",
      "meeting-room-email-address": "Adresse e-mail de la salle de réunion Outlook",
      "important": "Important",
      "important-message": "Les utilisateurs devront avoir leur synchronisation de calendrier active pour que les salles puissent être réservées dans Outlook ainsi que dans Team Today. Ce statut s'affichera en vert dans la Vue d'équipe.",
      "capacity": "Capacité",
      "office": "Bureau",
      "floor": "Étage",
      "edit": "Modifier la salle de réunion",
      "limit-title": "Limite de salles de réunion atteinte",
      "limit-description": "Contactez-nous à <0 href=\"mailto: support@team-today.com\">support@team-today.com</0> pour augmenter votre limite",
      "microsoft-link": "Lier cette salle à une salle de réunion dans Outlook",
      "microsoft-link-description": "Vous pouvez lier la salle à une salle dans Outlook en utilisant l'adresse e-mail de la salle. Cela nécessitera que les utilisateurs aient les autorisations de calendrier activées pour que la salle puisse être réservée dans Outlook ainsi que dans Team Today",
      "introduction": {
        "how": "Comment ça marche",
        "intro": "Ajoutez une salle de réunion dans Team Today plutôt que dans Outlook ou Google pour permettre :",
        "intro-1": "Aux membres de l'équipe de trouver facilement toutes les salles de réunion en un seul endroit",
        "intro-2": "Vérifier rapidement la disponibilité et réserver des salles",
        "intro-3": "Réserver des salles de réunion sur un plan d'étage interactif (si un plan d'étage a été ajouté)"
      },
      "meeting-room": "salle de réunion"
    },
    "looking-after-multiple-teams": "Vous gérez plusieurs équipes ?",
    "create-a-company": "Créez une vue d'entreprise pour voir toutes vos équipes en un seul endroit",
    "departments": {
      "title": "Gérer les départements",
      "add-new": "Ajouter un nouveau département",
      "add-members": "Ajouter de nouveaux membres"
    },
    "desk-booking": "Réservation de bureau",
    "office-information": "Informations sur le bureau",
    "office-information-how-it-works": "Les bureaux apparaissent pour que les utilisateurs puissent réserver dans Team Whereabouts. Vous pouvez attribuer des utilisateurs à un bureau qui sera leur emplacement par défaut.",
    "desk-bookings-how-it-works": "Les bureaux apparaissent pour que les utilisateurs puissent réserver dans Team Whereabouts. Vous pouvez attribuer des utilisateurs à un bureau qui sera leur emplacement par défaut.",
    "car-parking": "Parking",
    "car-parking-how-it-works": "Parking du bureau, contactez-nous pour gérer les places de parking avec une carte interactive.",
    "automatic-checkin": "Enregistrement automatique",
    "schengen": {
      "title": "Suivi Schengen",
      "subtitle": "Suivez le nombre de jours que les personnes passent dans l'espace Schengen"
    },
    "whereabouts-reminder-config": {
      "title": "Paramètres de rappel de localisation",
      "subtitle": "Envoyez des rappels hebdomadaires aux utilisateurs dans Microsoft Teams pour définir leur localisation.",
      "day": "Jour d'envoi du rappel",
      "day-placeholder": "Jour d'envoi",
      "hour": "Heure d'envoi du rappel",
      "hour-placeholder": "Heure d'envoi",
      "timezone": "Fuseau horaire",
      "timezone-placeholder": "Fuseau horaire",
      "enable": "Activer"
    },
    "carry-over": {
      "title": "Activer le report automatique",
      "description": "Reporte automatiquement les congés de l'année précédente",
      "carry-over-days": "Report maximum",
      "rules-title": "Ajouter des règles d'expiration",
      "rules-description": "Définissez une règle pour que les jours reportés soient utilisés avant une date définie",
      "expires-on": "Le report expire le"
    },
    "manage-hospitality": {
      "title": "Gérer l'hospitalité",
      "enable-hospitality": "Activer l'hospitalité",
      "add-new-item": "Ajouter un article d'hospitalité",
      "add-people-to-notify": "Ajouter des personnes à notifier",
      "important-note": "Aucune note importante définie",
      "important-note-title": "Notes importantes d'hospitalité (visibles par les employés)",
      "notifications": "Notifications",
      "add-people-message": "Ajoutez des personnes (par ex. assistants de bureau) à notifier lorsqu'une demande d'hospitalité est soumise.",
      "number-of-people-notifying": "{{count}} personnes notifiées.",
      "hospitality-description": "Ajoutez des articles (par ex. traiteur) que les employés peuvent demander pour les salles de réunion.",
      "menu-item": "Article du menu",
      "availability": "Disponibilité",
      "item-name": "Nom de l'article",
      "notes": "Notes",
      "price": "Prix",
      "currency": "Devise",
      "add-hospitality-item": "Ajouter un article d'hospitalité",
      "edit-important-note": "Modifier la note importante"
    },
    "notify-manager-on-leave-cancellation": {
      "title": "Cancellation notifications",
      "subtitle": "When enabled, a user's line manager is emailed when the user cancels their own approved leave (holiday or any approval-required leave type)."
    }
  },
  "edit-workgroup": {
    "edit-workgroup": "Gérer le groupe de travail",
    "edit-workgroup-name": "Modifier le nom du groupe de travail",
    "add-or-remove-members": "Ajouter ou supprimer des membres",
    "add-users-to-group": "Ajouter des utilisateurs au groupe",
    "select-users-to-add": "Sélectionner les utilisateurs à ajouter"
  },
  "week-notes": {
    "week-notes": "Notes hebdomadaires",
    "must-be-in-team": "Vous devez faire partie d'une équipe pour définir une note hebdomadaire",
    "save-failed": "Échec de l'enregistrement de la note hebdomadaire. Veuillez réessayer."
  },
  "personal-perf": {
    "personal-perf": "Préférences personnelles",
    "office-perf": "Préférences de bureau",
    "other-perf": "Autres préférences",
    "default-office-and-location": "Bureau et emplacement par défaut",
    "default-office-title": "Votre bureau et emplacement par défaut",
    "default-office-description": "Définir un bureau par défaut rend la définition des déplacements plus rapide. Vous pouvez toujours choisir n'importe quel autre bureau à visiter.",
    "require-space-title": "Exiger une place de parking",
    "require-space-description": "Activez ce paramètre si vous avez régulièrement besoin d'une place de parking lorsque vous visitez le bureau",
    "veh-registration": "Immatriculation du véhicule",
    "veh-colour": "Couleur du véhicule",
    "veh-make": "Marque du véhicule"
  },
  "approvals": {
    "approvals-title": "Approbations",
    "approved": "Approuvé",
    "cancelled": "Annulé",
    "days": "jours",
    "declined": "Refusé",
    "holiday-approvals": "Approbations",
    "no-results-found": "Aucun résultat trouvé",
    "no-approvals-found": "Aucune approbation trouvée"
  },
  "work-planner": {
    "work-planner": "Planificateur de travail",
    "show-other-teams": "Afficher les autres équipes",
    "events-and-projects": "Projets / Événements",
    "add-event-project": "Ajouter un projet / événement",
    "create-event-title": "Donnez un titre à votre projet / événement",
    "event-is-for": "L'événement / projet est pour",
    "select-teams-to-follow": "Sélectionner les équipes à suivre",
    "select-teams-to-follow-description": "Vous pouvez suivre trois équipes en plus de la vôtre.",
    "select-teams-to-follow-error": "Vous devez d'abord cesser de suivre une équipe avant d'en suivre une autre."
  },
  "textinput": {
    "from": "De",
    "date": "Date",
    "to": "À",
    "firstname": "Prénom",
    "lastname": "Nom",
    "office-location": "Lieu de travail (facultatif)",
    "jobTitle": "Poste",
    "email": "E-mail",
    "password": "Mot de passe",
    "repeat-password": "Répéter le mot de passe",
    "office-name": "Nom du bureau",
    "office-postcode": "Code postal du bureau",
    "desks-available": "Bureaux disponibles",
    "number-desks-available": "Nombre de bureaux disponibles",
    "number-desks-for-floor": "Définir le nombre de bureaux pour l'étage",
    "desks-available-each-day": "bureaux disponibles chaque jour",
    "floor-name": "Nom de l'étage",
    "add-individual-desks": "Ajouter des bureaux individuels",
    "areas-names-and-avail": "Noms et disponibilité des zones",
    "desk-names-and-avail": "Noms et disponibilité des bureaux",
    "search-existing-user": "Rechercher un utilisateur existant",
    "whereabouts-name": "Nom du déplacement",
    "holiday-title-or-reason": "Titre ou raison du congé",
    "company-settings": "Nom de l'entreprise",
    "team-name": "Nom de l'équipe",
    "enable-desk-booking": "Activer la réservation de bureau",
    "enable-car-parking": "Activer le parking",
    "add-date": "Ajouter une date",
    "select-placeholder": "Sélectionner...",
    "search": "Rechercher",
    "select-start-day": "Sélectionner un jour de début",
    "find-user": "Trouver un utilisateur",
    "mac-address-placeholder": "ex. AA:BB:CC:DD:EE:FF",
    "network-name-placeholder": "ex. Bureau-WiFi",
    "select-desk": "Sélectionner un bureau",
    "none-available": "Aucun disponible",
    "select-month": "Sélectionner un mois",
    "choose-an-office": "Choisir un bureau",
    "filter-users": "Filtrer les utilisateurs",
    "please-select": "Veuillez sélectionner",
    "select-team": "Sélectionner une équipe",
    "office-three-letter-code": "Code bureau à 3 lettres"
  },
  "button": {
    "filters": "Filtres",
    "setup-offices": "Configurer les bureaux",
    "change-office": "Changer de bureau",
    "choose-day": "Choisir un jour",
    "save-changes": "Enregistrer les modifications",
    "back-and-change": "Retourner et modifier",
    "view-whereabouts-report": "Voir mon rapport de présence",
    "continue": "Continuer",
    "done": "Terminé",
    "update": "Mettre à jour",
    "edit": "Modifier",
    "reset-to-current-week": "Réinitialiser à la semaine en cours",
    "view-floor-plan": "Voir le plan d'étage",
    "your-holidays": "Planificateur de congés",
    "requests": "Approbations",
    "team-holidays": "Congés de l'équipe",
    "approvals-required": "Approbations requises",
    "view-approvals": "Approbations",
    "team-view": "Vue d'équipe",
    "back-to-team-view": "Retour à la vue d'équipe",
    "settings": "Paramètres",
    "company-view": "Vue d'entreprise",
    "my-requests": "Mes demandes",
    "work-planner": "Planificateur de travail",
    "my-holiday-requests": "Mes demandes de congé",
    "holiday-requests": "Demandes de congé",
    "office-view": "Vue de bureau",
    "all-teams": "Toutes les équipes",
    "floor-plan": "Plan d'étage",
    "create-new-work-group": "Créer un nouveau groupe de travail",
    "create-new-team": "Créer une nouvelle équipe",
    "create-new-group": "Créer un nouveau groupe",
    "create-new-department": "Créer un nouveau département",
    "link-team-or-workgroup": "Lier une équipe ou un groupe à un bureau",
    "finish-setting-up-your-account": "Terminer la configuration de votre compte",
    "filter-by-office": "Filtrer les équipes et groupes de travail par bureau",
    "save-whereabouts": "Enregistrer les déplacements",
    "clear-day": "Effacer le jour",
    "add-holiday-request": "Ajouter un congé",
    "add-holiday": "Ajouter un congé",
    "am": "AM",
    "pm": "PM",
    "all-day": "Toute la journée",
    "book-holiday": "Demander un congé",
    "delete-holiday-request": "Supprimer la demande de congé",
    "book-am": "Réserver AM",
    "book-pm": "Réserver PM",
    "book-all-day": "Réserver toute la journée",
    "am-only": "AM uniquement",
    "pm-only": "PM uniquement",
    "login-to-your-account": "Se connecter à votre compte",
    "continue-to-signup": "Continuer vers l'inscription",
    "user-view": "Vue utilisateur",
    "tag-manager": "Gestionnaire de groupes de travail",
    "edit-and-manage-team": "Modifier et gérer l'équipe",
    "edit-and-manage-workgroup": "Modifier et gérer le groupe de travail",
    "edit-and-manage-department": "Modifier et gérer le département",
    "add-another-team": "Ajouter une autre équipe",
    "add-another-team-member": "Ajouter un autre membre d'équipe",
    "set-up-company-and-add-teams": "Configurer l'entreprise et ajouter des équipes",
    "add-new-favourite": "Ajouter un nouveau favori",
    "logout": "Déconnexion",
    "move-another-user": "Ajouter un autre membre d'équipe",
    "done-for-now": "Terminé pour l'instant",
    "add-to-team": "Ajouter à l'équipe",
    "approve": "Approuver",
    "decline": "Refuser",
    "approved": "Approuvé",
    "declined": "Refusé",
    "pending": "En attente",
    "add-new-tag": "Ajouter un nouveau groupe de travail",
    "edit-tags": "Modifier les groupes de travail",
    "setup-multiple-offices": "Configurer plusieurs bureaux",
    "delete-office": "Supprimer le bureau",
    "add-new-desk": "Ajouter un nouveau bureau",
    "add-new-area": "Ajouter une nouvelle zone",
    "send-invite": "Envoyer l'invitation",
    "add-team-member": "Ajouter un membre d'équipe",
    "delete-team": "Supprimer l'équipe ?",
    "download-csv": "Télécharger .csv",
    "download-excel": "Exporter vers Excel",
    "send-reminder": "Envoyer un rappel",
    "retry": "Réessayer",
    "go-back": "Retour",
    "finish-and-save": "Terminer et enregistrer",
    "add-members": "Ajouter des membres",
    "close": "Fermer",
    "add-team-members": "Ajouter des membres d'équipe",
    "add-later": "Je le ferai plus tard",
    "upgrade": "Mettre à niveau mon compte",
    "create": "Créer",
    "checkout": "Paiement",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "confirm": "Confirmer",
    "save": "Enregistrer",
    "confirm-delete-team": "Oui, supprimer l'équipe",
    "reject-delete-team": "Non, ne pas supprimer l'équipe",
    "create-company": "Créer une entreprise",
    "setup-more-teams": "Configurer d'autres équipes",
    "ok": "OK",
    "fetch-users-from-microsoft": "Récupérer les utilisateurs de Microsoft",
    "add-company-holiday": "Ajouter un congé d'entreprise",
    "got-it": "Compris",
    "confirm-delete-user": "Oui, supprimer l'utilisateur",
    "reject-delete-user": "Non, ne pas supprimer l'utilisateur",
    "lets-go": "Allons-y",
    "create-office": "Créer un bureau",
    "EDIT": "MODIFIER",
    "add-another-holiday": "Ajouter un autre congé",
    "upgrade-my-account": "Mettre à niveau mon compte",
    "view-report": "Voir le rapport",
    "yes-delete": "Oui, supprimer.",
    "cancel": "Annuler",
    "delete-user": "Supprimer l'utilisateur",
    "change": "Changer",
    "edit-office": "Modifier le bureau",
    "create-new-office": "Créer un nouveau bureau",
    "add-bookable-area": "Ajouter une zone réservable",
    "add-new-line-report": "Ajouter un nouveau rapport hiérarchique",
    "assign-users-to-team": "Assigner des utilisateurs à des équipes",
    "full": "Complet",
    "free": "Gratuit",
    "partial": "Partiel",
    "not-available": "Non disponible",
    "oof": "Hors bureau",
    "working-elsewhere": "Travailler ailleurs",
    "delete": "Supprimer",
    "save-company-holiday": "Enregistrer le congé d'entreprise",
    "delete-holiday": "Supprimer le congé",
    "delete-account": "Supprimer toutes les équipes et données",
    "book": "Réserver",
    "view": "Voir",
    "delete-event-project": "Supprimer l'événement",
    "view-subscription": "Gérer le moyen de paiement",
    "create-subscription": "Créer un abonnement",
    "try-again": "Réessayer",
    "month-view": "Vue mensuelle",
    "year-view": "Vue annuelle",
    "download-office-attendees": "Télécharger le rapport de présence au bureau (.xls)",
    "download-car-park-attendees": "Télécharger le rapport de présence au parking (.xls)",
    "team-report": "Rapport d'équipe",
    "department-report": "Rapport de département",
    "user-report": "Rapport utilisateur",
    "create-team": "Créer une équipe",
    "turn-on-in-settings": "Activer dans les paramètres",
    "log-in": "Se connecter",
    "today": "Aujourd'hui",
    "add-new-space": "Ajouter un nouvel espace",
    "show-more": "Afficher plus",
    "show-less": "Afficher moins",
    "yes": "Oui",
    "week-view": "Vue semaine",
    "workgroup-report": "Rapport de groupe de travail"
  },
  "loading": {
    "saving-whereabouts": "Enregistrement des déplacements"
  },
  "View floor plan": "Voir le plan d'étage",
  "dates": {
    "this-week": "Cette semaine"
  },
  "checkbox": {
    "first-aider": "Premier secours",
    "fire-warden": "Agent de sécurité incendie",
    "mental-first-aider": "Premier secours en santé mentale",
    "key-holder": "Détenteur de clé"
  },
  "whereaboutsAvailability": {
    "show-avail-calendar-like": "Afficher la disponibilité sur le calendrier comme :",
    "show-as-free": "Cela s'affichera comme <strong>Libre</strong> dans votre calendrier.",
    "show-as-tentative": "Cela s'affichera comme <strong>Provisoire</strong> dans votre calendrier.",
    "show-as-busy": "Cela s'affichera comme <strong>Occupé</strong> dans votre calendrier.",
    "show-as-oof": "Cela s'affichera comme <strong>Hors bureau</strong> dans votre calendrier (Outlook uniquement).",
    "show-as-working-elsewhere": "Cela s'affichera comme <strong>Travailler ailleurs</strong> dans votre calendrier (Outlook uniquement)."
  },
  "company-settings-page": {
    "whereabouts-management-tab": "Gestion de la localisation",
    "visitors-tab": "Visiteurs",
    "edit-company": "Modifier l'entreprise",
    "company-settings": "Paramètres de l'entreprise",
    "company-preferences": "Préférences de l'entreprise",
    "edit-global": "Modifier les paramètres globaux",
    "signup-and-register": "Paramètres d'inscription et d'enregistrement",
    "azure-and-active-dir-settings": "Paramètres Azure et Active Directory",
    "other": "Autres paramètres",
    "notifications": "Paramètres de notification",
    "tenant-id": "ID de locataire Azure",
    "general": "Général",
    "danger-zone": "Zone de danger",
    "notifications-tab": "Notifications",
    "signup-and-register-tab": "Inscription et enregistrement",
    "azure-configuration": "Configuration Azure",
    "other-tab": "Autre",
    "api-keys-tab": "API Keys",
    "api-keys": {
      "public-api": {
        "title": "Public API key",
        "description": "Used by external integrations calling the Team Today public API."
      },
      "scim": {
        "title": "SCIM API key",
        "description": "Used by SCIM clients to provision and sync users."
      },
      "no-key": "No key generated yet.",
      "label": "Label",
      "label-placeholder": "e.g. Okta production",
      "unlabeled": "Unlabeled",
      "edit-label": "Edit label",
      "save-label": "Save",
      "cancel": "Cancel",
      "generate": "Generate key",
      "generate-additional": "Generate new key",
      "regenerate": "Regenerate",
      "revoke": "Revoke",
      "copy": "Copy",
      "copied": "Copied!",
      "confirm-regenerate": "This will invalidate the current key. Any integration using it will stop working. Continue?",
      "confirm-revoke": "This will delete the current key. Any integration using it will stop working. Continue?"
    }
  },
  "company-view-page": {
    "workgroups": "Groupes de travail",
    "choose-office-to-view": "Choisir un bureau",
    "create-an-office": {
      "title": "Créer un bureau",
      "description": "Définissez une limite au nombre de bureaux disponibles pour que les collègues sachent quand venir au bureau."
    },
    "sidebar": {
      "create-work-group": "Créer un groupe de travail ?",
      "create-work-group-description": "Créez des groupes de travail pour permettre aux utilisateurs d'appartenir à plusieurs équipes"
    },
    "all-teams": "Toutes les équipes",
    "work-groups": "Groupes de travail",
    "create-new-group": "Créer un nouveau groupe ?",
    "create-new-department": "Créer un nouveau département ?",
    "no-members-in-workgroup": "Aucun membre dans le groupe de travail pour l'instant",
    "no-members-in-workgroup-description": "Les groupes de travail permettent aux utilisateurs d'appartenir à plusieurs équipes ou départements",
    "area-unavailable": "'Zone - Indisponible'",
    "area": "Zone :",
    "no-one-booked-in-area": "Personne n'a réservé dans cette zone",
    "departments": "Départements"
  },
  "custom-whereabouts-page": {
    "whereabouts": "Déplacements",
    "available-in-team-view": "Disponible dans la Vue d'équipe, les déplacements permettent à votre équipe de planifier sa semaine de travail.",
    "how-it-works": "Comment ça marche",
    "custom-whereabouts-requirements": "Les déplacements suivants sont requis par le système pour fonctionner correctement, mais vous pouvez ajouter d'autres déplacements personnalisés ci-dessous.",
    "promo-title": "Créer et gérer des déplacements personnalisés",
    "promo-message": "Ajoutez des déplacements personnalisés pour donner à vos équipes plus d'options telles que Hors site, Formation, Maladie et obtenez des rapports détaillés dans la section des rapports.",
    "enable-whereabouts-option": "Activer cette option de déplacement",
    "day-notes-title": "Activer les notes quotidiennes",
    "day-notes-description": "Ajoute un champ de texte libre à l'option de déplacement",
    "schengen-title": "Activer le suivi Schengen",
    "schengen-description": "Cette localisation comptera comme un jour Schengen",
    "description": "Permettez à votre équipe de planifier sa semaine de travail.",
    "default": "Par défaut",
    "create-title": "Créer un déplacement personnalisé",
    "step-1-name": "1. Nom du déplacement",
    "step-2-icon": "2. Choisir une icône",
    "step-3-availability": "3. Afficher la disponibilité sur le calendrier Outlook ou Google comme :",
    "final-setup": "Configuration finale",
    "option-list-title": "Proposer une liste d'options aux utilisateurs",
    "option-list-description": "Lorsqu'un utilisateur sélectionne ce déplacement, il devra choisir dans la liste ci-dessous",
    "option-list-upsell": "Les listes d'options sont disponibles avec les forfaits Premium et Enterprise.",
    "option-list-upsell-link": "Mettre à niveau votre forfait",
    "option-list-not-enabled": "Cette fonctionnalité n'est pas activée sur votre compte. Contactez",
    "option-list-add-option": "Ajouter une option",
    "option-list-free-text-title": "Autoriser le texte libre",
    "option-list-free-text-description": "Les utilisateurs peuvent aussi saisir leur propre réponse au lieu de choisir dans la liste",
    "delete-whereabouts": "Supprimer ce déplacement"
  },
  "dialog": {
    "create-workgroup": "Créer un groupe de travail",
    "add-new-team": "Ajouter une nouvelle équipe",
    "add-people-to-team-message": "Ok, ajoutons quelques personnes à cette équipe",
    "max-teams-header-msteams": "Vous avez épuisé vos équipes",
    "max-teams-header": "Vous avez atteint la limite maximale d'équipes",
    "max-teams-message-msteams": "Vous avez atteint la limite maximale d'équipes.",
    "max-teams-message": "Vous avez utilisé votre allocation d'équipes, supprimez-en certaines ou mettez à niveau votre compte.",
    "add-company-to-add-more-teams": "Ajoutez une entreprise pour ajouter plus d'équipes",
    "add-self-to-team": "Ajoutez-vous à l'équipe",
    "add-self-to-team-warning": "Cela mettra à jour l'équipe actuelle dans laquelle vous êtes.",
    "selected-number-of-users-to-report-to-a-user": "Vous avez sélectionné {{userCount}} personnes qui relèvent de cette personne.",
    "week-notes": "Notes hebdomadaires",
    "no-week-notes": "Aucune note définie pour l'équipe",
    "week-note-request-not-made": "La demande n'a pas encore été faite",
    "week-notes-not-in-a-team": "Vous n'êtes pas dans une équipe. Vous ne pouvez définir une note que lorsque vous êtes dans une équipe.",
    "add-note": "Ajouter une note",
    "week-note-last-updated": "Mis à jour {{lastUpdated}}",
    "saved-whereabouts-errors-title": "Important : impossible d'enregistrer certaines de vos réservations de bureau futures",
    "saved-whereabouts-errors-content-1": "La politique de réservation de bureau de votre entreprise limite les réservations futures pour {{officeName}} à {{weeksAhead}} semaines à l'avance.",
    "saved-whereabouts-errors-content-2": "Actuellement, vous ne pouvez réserver {{officeName}} que jusqu'à la semaine se terminant le {{weekEnding}}.",
    "saved-whereabouts-errors-content-2-fallback": "Actuellement, vous ne pouvez pas réserver des déplacements aussi loin à l'avance.",
    "parking-whereabouts-errors-title": "Parking indisponible certains jours",
    "parking-whereabouts-errors-date": "Aucune place de parking disponible le {{date}}",
    "general-whereabouts-errors-title": "",
    "unable-to-book-desks-far-in-advance-title": "Impossible de réserver des bureaux trop longtemps à l'avance",
    "unable-to-book-desks-far-in-advance-para1": "La politique de réservation de bureau de votre entreprise limite les réservations futures pour le bureau {{officeName}} à {{bookingWindow}} semaines à l'avance.",
    "unable-to-book-desks-far-in-advance-para2": "Actuellement, vous ne pouvez réserver le bureau {{officeName}} que jusqu'à la semaine commençant le {{weekCommencing}}.",
    "cannot-edit-approved-holiday-title": "Impossible de modifier un congé approuvé",
    "cannot-edit-approved-holiday-para1": "Pour annuler une réservation de congé :",
    "cannot-edit-approved-holiday-list1": "Allez dans le Planificateur de congés",
    "cannot-edit-approved-holiday-list2": "Allez dans l'onglet Congés",
    "cannot-edit-approved-holiday-list3": "Appuyez sur le crayon de modification sur le congé que vous souhaitez annuler",
    "cannot-edit-approved-holiday-list4": "Supprimer la demande de congé",
    "cannot-edit-approved-holiday-para2": "Cela annulera la demande de congé.",
    "booked": "Réservé",
    "unavailable": "Indisponible"
  },
  "approved-holiday-whereabouts-errors": {
    "title": "Impossible de modifier un congé approuvé",
    "line1": "Pour annuler une réservation de congé :",
    "line2": "Allez dans le <strong>Planificateur de congés</strong>",
    "line3": "Allez dans l'onglet <strong>Congés</strong>",
    "line4": "Appuyez sur le <strong>Crayon de modification</strong> sur le congé que vous souhaitez annuler",
    "line5": "<strong>Supprimer la demande de congé</strong>",
    "line6": "Cela annulera la demande de congé."
  },
  "add-multiple-users-dialog": {
    "title": "Ajouter plusieurs utilisateurs"
  },
  "usage-dialog": {},
  "side-of-day-dialog": {
    "title": "Combien de temps avez-vous besoin du bureau ?"
  },
  "day-notes-dialog": {
    "add-note": "Ajouter une note",
    "recent-notes": "Notes récentes"
  },
  "whereabouts-option-picker-dialog": {
    "pick-option": "Choisissez une option",
    "or-free-text": "Ou saisissez votre propre réponse",
    "skip": "Continuer sans choisir"
  },
  "settings-page": {
    "title": "Paramètres",
    "manage-users": "Gérer les utilisateurs actuels",
    "manage-users-1": "Modifier, gérer et ajouter de nouveaux utilisateurs",
    "manage-users-2": "Modifier les permissions des utilisateurs et le bureau par défaut",
    "manage-users-3": "Ajouter des rôles clés aux utilisateurs tels que les agents de sécurité incendie",
    "manage-teams": "Gérer les équipes, les groupes de travail et les départements",
    "manage-teams-1": "Modifier, gérer et ajouter de nouvelles équipes",
    "manage-teams-2": "Voir les membres de l'équipe",
    "teams-tab": "Équipes",
    "workgroups-tab": "Groupes de travail",
    "no-workgroups-message": "Les utilisateurs peuvent être ajoutés à plusieurs groupes de travail pour faciliter leur regroupement entre équipes et départements.",
    "departments-tab": "Départements",
    "manage-departments": "Gérer les départements",
    "manage-departments-1": "Modifier, gérer et ajouter de nouveaux départements",
    "manage-departments-2": "Voir les membres du département",
    "whereabouts": "Déplacements personnalisés",
    "whereabouts-1": "Choisissez des emplacements de déplacement supplémentaires",
    "whereabouts-2": "Ajoutez plusieurs emplacements hors site",
    "reports": "Rapports, données et journaux d'audit",
    "report-1": "Voir les rapports sur l'utilisation du bureau",
    "report-2": "Voir les rapports sur les déplacements et les congés",
    "report-3": "Télécharger et exporter des rapports vers Excel",
    "office": "Bureaux et salles de réunion",
    "office-1": "Créer et gérer les emplacements de bureaux, plans d'étage et postes de travail.",
    "office-2": "Configurer les salles de réunion et synchroniser avec Outlook.",
    "office-3": "Gérer le parking et autres espaces réservables.",
    "holiday": "Paramètres de congé",
    "holiday-1": "Activer le suivi des congés et configurer les approbations",
    "holiday-2": "Changer le début et la fin de l'année de congé",
    "holiday-3": "Ajouter des congés nationaux et d'entreprise",
    "meeting-rooms": "Salles de réunion",
    "meeting-rooms-1": "Créer et modifier des salles de réunion réservables",
    "meeting-rooms-2": "Synchroniser les salles de réunion avec les salles de réunion Outlook",
    "company": "Paramètres de l'entreprise",
    "company-1": "Contrôler les paramètres à l'échelle de l'entreprise",
    "company-2": "Autoriser les nouveaux utilisateurs de votre entreprise à se connecter",
    "company-3": "Changer le pack d'icônes et configurer les planifications répétitives",
    "personal": "Préférences personnelles",
    "personal-pref-1": "Gérer la synchronisation du calendrier (Outlook et Gmail)",
    "personal-pref-2": "Gérer les bureaux et bureaux favoris",
    "personal-pref-3": "Entrer les informations de voiture pour le parking",
    "billing": "Paramètres de facturation et de plan",
    "billing-1": "Augmenter ou diminuer votre abonnement",
    "billing-2": "Voir vos factures et reçus",
    "how-desk-capacities-work": "Activez la réservation de bureau si vous souhaitez gérer les capacités des bureaux ou diviser un bureau en étages et zones. Si vous souhaitez inclure un plan d'étage interactif, envoyez simplement un diagramme de référence à <0>hello@team-today.com</0>.",
    "how-desk-capacities-work-title": "Comment ça marche",
    "edit-user": {
      "title": "Modifier l'utilisateur",
      "email-address": "Adresse e-mail",
      "member-of-team": "Membre de l'équipe",
      "member-of-department": "Membre du département",
      "member-of-workgroups": "Membre des groupes de travail",
      "not-assigned-to-workgroups": "N'appartient à aucun groupe de travail",
      "location-title": "Emplacement",
      "location-message": "Définir un emplacement par défaut rend le choix d'un bureau plus rapide pour les collègues. Ils peuvent toujours choisir n'importe quel bureau à visiter.",
      "office-base": "Bureau de base",
      "standard-user": "Utilisateur standard",
      "basic-permissions": "Peut uniquement définir ses propres déplacements",
      "department-admin-permissions-1": "Gestion complète du département",
      "department-admin-permissions-2": "Peut voir et mettre à jour tous les utilisateurs du département",
      "department-admin": "Administrateur de département",
      "team-admin": "Administrateur d'équipe",
      "team-admin-permissions-1": "Gestion complète de l'équipe, y compris l'ajout et la suppression de membres",
      "team-admin-permissions-2": "Peut ajouter de nouveaux utilisateurs et mettre à jour leurs informations",
      "team-admin-permissions-3": "Peut rendre d'autres utilisateurs administrateurs d'équipe",
      "office-admin": "Administrateur de bureau",
      "office-admin-permissions-1": "Gestion complète du bureau désigné par défaut de l'utilisateur",
      "office-admin-permissions-2": "Peut mettre à jour les déplacements de bureau d'autres utilisateurs",
      "office-admin-permissions-3": "Accès aux rapports de bureau",
      "office-admin-permissions-4": "Peut rendre d'autres utilisateurs administrateurs d'équipe",
      "company-admin": "Administrateur de l'entreprise",
      "company-admin-permissions-1": "Gestion complète de l'entreprise, y compris la création et la suppression d'équipes",
      "company-admin-permissions-2": "Modification des détails de l'entreprise",
      "company-admin-permissions-3": "Ajouter ou supprimer des utilisateurs dans n'importe quelle équipe",
      "permissions": "Permissions",
      "holiday-allowance": "Quota de congés individuel pour l'année",
      "holiday-allowance-message": "Cela remplace le quota de congés par défaut de l'entreprise. Cela sera réinitialisé au début de l'année de congé pour revenir à la valeur par défaut de l'entreprise.",
      "users-allowance": "Définir le quota de congés pour l'année",
      "for-year": "jours pour l'année",
      "holiday-allowance-taken-from-users-setting": "Le quota de congés actuel est pris à partir de ce paramètre utilisateur",
      "holiday-allowance-taken-from-company-setting": "Le quota de congés actuel est pris à partir des paramètres de l'entreprise",
      "holiday-allowance-not-yet-set": "Le quota de congés actuel n'a pas été défini dans les paramètres de l'entreprise ou dans ce paramètre utilisateur.",
      "additional-responsibilities": "Responsabilités supplémentaires",
      "additional-responsibilities-message": "Créez des agents de sécurité incendie et des premiers secours pour voir facilement s'il y en a dans un bureau.",
      "access-permitted-title": "Accès à Team Today",
      "access-permitted-description": "L'utilisateur existera toujours dans Team Today mais ne pourra pas se connecter.",
      "birthday": {
        "title": "Partagez votre anniversaire",
        "description": "Faites savoir aux autres quand votre anniversaire approche, cela s'affichera dans la vue d'équipe et le planificateur de travail.",
        "month": "Mois",
        "day": "Jour"
      }
    }
  },
  "audit-logs-page": {
    "title": "Journaux d'audit",
    "search": "Rechercher",
    "search-placeholder": "Rechercher par personne ou description",
    "action": "Action",
    "source": "Source",
    "all-actions": "Toutes les actions",
    "all-sources": "Toutes les sources",
    "showing": "Affichage de {{shown}} sur {{total}} entrées",
    "no-results": "Aucune entrée du journal d'audit ne correspond à vos filtres.",
    "load-more": "Charger plus",
    "error": "Échec du chargement des journaux d'audit. Veuillez réessayer.",
    "category": "Catégorie",
    "all-categories": "Toutes les catégories",
    "col-date": "Date",
    "col-action": "Action",
    "col-user": "Utilisateur",
    "col-affected": "Utilisateur concerné",
    "col-source": "Source",
    "col-description": "Description",
    "categories": {
      "HOLIDAYS": "Congés et absences",
      "WHEREABOUTS": "Localisations",
      "USER_MANAGEMENT": "Gestion des utilisateurs",
      "MEETING_ROOMS": "Salles de réunion",
      "COMPANY_SETTINGS": "Paramètres de l'entreprise",
      "SECURITY": "Sécurité et clés API",
      "NOTIFICATIONS": "Notifications"
    },
    "sources": {
      "WEB": "Web",
      "SCIM": "SCIM",
      "SCHEDULER": "Planificateur",
      "PUBLIC_API": "API publique",
      "SYSTEM": "Système"
    }
  },
  "manage-users-page": {
    "title": "Gérer les utilisateurs",
    "search": "Rechercher un utilisateur",
    "showing-users": "Affichage de {{skip}} - {{count}} sur {{total}} utilisateurs",
    "not-logged-in": "Non connecté",
    "resend-invite": "Renvoyer l'invitation",
    "account": "Compte",
    "user-count": "{{count}} utilisateurs",
    "free-spaces-count": "{{count}} places libres",
    "add-multiple-users": "Ajouter plusieurs utilisateurs",
    "assign-to-office": "Assigner à un bureau",
    "assign-to-department": "Assigner à un département",
    "assign-to-team": "Assigner à une équipe",
    "manage-teams": "Gérer les équipes",
    "manage-workgroups": "Gérer les groupes de travail",
    "export-users": "Exporter les utilisateurs",
    "assign-to-workgroup": "Assigner à un groupe de travail",
    "select-all": "Tout sélectionner"
  },
  "holiday": {
    "holiday-year": "Année de congé",
    "days-left": "Jours restants",
    "days-taken-or-booked": "Jours pris ou réservés",
    "company-holiday": "Congé d'entreprise",
    "holiday-booking": "Réservation de congé",
    "your-summary": "Votre résumé",
    "your-bookings": "Vos réservations",
    "users-bookings": "Réservations de {{firstName}}",
    "holiday-booked": "Congé réservé"
  },
  "company-holiday": {
    "title": "Congé d'entreprise",
    "description": "Les congés d'entreprise seront ajoutés aux calendriers de tout le monde et empêcheront toute réservation dans le bureau",
    "number-of-holidays": "Nombre de congés"
  },
  "unsubscribe-page": {
    "unsubscribed-title": "Désabonné",
    "unsubscribed-message-1": "Vous avez été désabonné des e-mails de rappel de Team Today.",
    "unsubscribed-message-2": "Vous pouvez vous réabonner en vous connectant et en visitant la zone des paramètres.",
    "unsubscribed-failed-title": "Échec du désabonnement",
    "unsubscribed-failed-message": "Une erreur s'est produite lors de votre désabonnement.",
    "unsubscribed-contact": "Envoyez-nous un e-mail à <0>hello@team-today.com</0> pour obtenir de l'aide pour vous désabonner."
  },
  "reports-page": {
    "reporting": "Rapports",
    "office-usage-title": "Utilisation du bureau",
    "office-usage-description": "Voir les statistiques et les données sur l'utilisation du bureau",
    "wfh-title": "Rapports de travail à domicile",
    "wfh-description": "Statistiques et données sur le travail à domicile",
    "whereabouts-title": "Déplacements",
    "all-departments": "Tous les départements",
    "all-workgroups": "Tous les groupes de travail",
    "whereabouts-description": "Statistiques et données sur tous les déplacements",
    "unknown-title": "Déplacements inconnus",
    "unknown-description": "Voir les utilisateurs sans déplacements définis",
    "line-reports-title": "Rapports hiérarchiques",
    "line-reports-description": "Voir qui relève de qui",
    "holiday-usage-title": "Utilisation des congés",
    "holiday-usage-description": "Voir combien de jours les gens ont pris et combien il leur en reste",
    "checkin-title": "Enregistrement au bureau",
    "checkin-description": "Voir comment les gens utilisent le bureau",
    "automatic-checkin-title": "Enregistrement automatique au bureau",
    "automatic-checkin-description": "Voir les enregistrements automatiques par détection réseau",
    "user-report": "Rapport utilisateur",
    "department-report": "Rapport de département",
    "user-breakdown-title": "Rapport utilisateur",
    "user-breakdown-description": "Résumé des déplacements d'un utilisateur",
    "user-breakdown-select-user-title": "Pour continuer",
    "user-breakdown-select-user-description": "Recherchez un utilisateur pour voir un résumé de ses déplacements sur une période donnée.",
    "fire-booked-in": "Agents de sécurité incendie réservés",
    "no-fire-booked-in": "Aucun agent de sécurité incendie dans le bureau",
    "first-booked-in": "Premiers secours réservés",
    "no-first-booked-in": "Aucun premier secours dans le bureau",
    "weeks-office-usage": "Utilisation du bureau cette semaine",
    "updated-hourly": "Mis à jour toutes les heures",
    "office-usage-report": "Rapport d'utilisation du bureau",
    "download-office-report": "Télécharger le rapport de bureau",
    "download-report": "Télécharger un rapport",
    "choose-an-office": "Choisir un bureau",
    "no-data-found": "Aucune donnée trouvée pour cette sélection",
    "select-office-from-past-two-years": "Veuillez sélectionner un bureau et une date passée dans les 2 dernières années.",
    "create-a-report": "Créer un rapport",
    "office-usage-confirmation": "Utilisation du bureau vs. confirmation",
    "typical-office-usage": "Utilisation typique du bureau",
    "download-holiday-summary": "Télécharger le rapport de congé",
    "download-absence-summary": "Télécharger le rapport d'absence",
    "edit-holiday-allowance": "Modifier le quota de congés",
    "unknown-whereabouts": {
      "title": "Déplacement inconnu",
      "note": "Note",
      "all-users-have-whereabouts-set": "Tous les utilisateurs de votre sélection ont leurs déplacements définis.",
      "reminder-last-sent": "rappel envoyé il y a {{days}} jours"
    },
    "whereabouts-report": {
      "no-date": "Aucune donnée trouvée pour cette sélection",
      "select-a-date": "Veuillez sélectionner une date dans les 2 dernières années.",
      "title": "Rapport de localisation",
      "high-level-report": "Rapport général",
      "detailed-report": "Rapport détaillé"
    },
    "holidays-report": {
      "days-used": "Jours utilisés",
      "allowance": "Quota",
      "team-name": "Nom de l'équipe",
      "user": "Utilisateur",
      "percentage": "%",
      "holiday-year": "Année de congé : {{year}}",
      "high-level-report": "Rapport général .xls",
      "detailed-report": "Rapport détaillé .xls",
      "report": "Télécharger le rapport",
      "office": "Au bureau (Total)"
    },
    "key-responsib": {
      "title": "Incendie et sécurité",
      "description": "rapport et données",
      "nothing-selected": "Sélectionnez un bureau",
      "one-fire-warden": "Un agent de sécurité incendie pour",
      "one-first-aider": "Un premier secours pour",
      "staff": "personnel",
      "fire-warden": "Agent de sécurité incendie",
      "first-aider": "Premier secours",
      "office-capacity": "Capacité du bureau : {{officeCapacity}}",
      "people-in-office": "Personnes dans le bureau : {{peopleInOffice}}",
      "key-role-in-office": "Rôle clé dans le bureau : {{keyRoleInOffice}}",
      "loading": "Récupération des données, cela peut prendre une minute",
      "nothing-selected-title": "Rien à afficher"
    },
    "users-whereabouts-title": "Localisations des utilisateurs",
    "users-whereabouts-description": "Statistiques et données sur la localisation des utilisateurs individuels",
    "desk-utilization-title": "Utilisation des bureaux",
    "desk-utilization-description": "Voyez comment les bureaux sont utilisés dans vos locaux",
    "desk-utilization-download-description": "Téléchargez un CSV montrant le statut de réservation quotidien de chaque bureau (1 = journée complète, 0,5 = demi-journée, 0 = non réservé) pour la période sélectionnée.",
    "desk-utilization-report-title": "Rapport d'utilisation des bureaux",
    "desk-utilization-office": "Bureau",
    "desk-utilization-no-data": "Aucune donnée trouvée",
    "desk-utilization-no-data-description": "Sélectionnez un bureau et une période pour voir l'utilisation des bureaux.",
    "desk-utilization-total-desks": "Total des bureaux",
    "desk-utilization-total-bookings": "Total des réservations",
    "desk-utilization-days-in-range": "Jours dans la période",
    "desk-utilization-utilization": "Utilisation",
    "desk-utilization-by-floor": "Utilisation par étage",
    "desk-utilization-by-office": "Utilisation par bureau",
    "desk-utilization-top-desks": "10 bureaux les moins utilisés",
    "desk-utilization-top-offices": "10 bureaux les moins utilisés",
    "desk-utilization-company-wide": "Toute l'entreprise",
    "desk-utilization-floor-breakdown": "Détail par étage",
    "desk-utilization-floor": "Étage",
    "desk-utilization-desks": "Bureaux",
    "desk-utilization-bookings": "Réservations",
    "desk-utilization-days": "Jours",
    "desk-utilization-download-title": "Télécharger le rapport d'utilisation des bureaux",
    "car-park-utilization-title": "Utilisation du parking",
    "car-park-utilization-description": "Voyez comment les places de parking sont utilisées dans vos locaux",
    "audit-logs-title": "Journaux d'audit",
    "audit-logs-description": "Voyez qui a modifié quoi dans votre entreprise",
    "car-park-utilization-report-title": "Rapport d'utilisation du parking",
    "car-park-utilization-office": "Bureau",
    "car-park-utilization-no-data": "Aucune donnée trouvée",
    "car-park-utilization-no-data-description": "Sélectionnez un bureau et une période pour voir l'utilisation du parking.",
    "car-park-utilization-total-capacity": "Capacité totale",
    "car-park-utilization-total-bookings": "Total des réservations",
    "car-park-utilization-days-in-range": "Jours dans la période",
    "car-park-utilization-utilization": "Utilisation",
    "car-park-utilization-by-office": "Utilisation par bureau",
    "car-park-utilization-company-wide": "Toute l'entreprise",
    "car-park-utilization-office-breakdown": "Détail par bureau",
    "car-park-utilization-capacity": "Capacité",
    "car-park-utilization-bookings": "Réservations",
    "car-park-utilization-days": "Jours",
    "car-park-utilization-daily-breakdown": "Détail quotidien",
    "car-park-utilization-daily-utilization": "Utilisation quotidienne",
    "car-park-utilization-date": "Date",
    "car-park-utilization-bottom-spaces": "10 places les moins utilisées",
    "office-usage": {
      "choose-office": "Choisir un bureau",
      "choose-group": "Choisir équipe, groupe ou dépt.",
      "choose-floor": "Choisir un étage",
      "custom": "Saisir une période personnalisée",
      "exit-custom": "Quitter la période personnalisée",
      "download-btn": "Télécharger le rapport d'étage",
      "download-desk-usage-btn": "Télécharger le rapport d'utilisation des bureaux",
      "capacity": "{{capacity}}% Capacité",
      "occupancy": "Occupation de l'étage",
      "deskUsage": "Utilisation des bureaux",
      "top10Desks": "10 bureaux les plus utilisés",
      "bottom10Desks": "10 bureaux les moins utilisés"
    }
  },
  "holidays": {
    "company-holidays-applies-to": "Choisissez les bureaux auxquels cela s'applique :",
    "edit-holiday-title": "Modifier le congé",
    "add-holiday-title": "Ajouter un congé",
    "holidays": "Mes congés",
    "holidays-disabled": "Gestion des congés actuellement désactivée",
    "holidays-disable-how-to-enable": "Pour activer la gestion des congés, y compris les approbations, activez-la simplement dans la zone des paramètres.",
    "holiday-duration": "{{duration}} jours",
    "add-new-leave": "Ajouter un nouveau congé",
    "add-leave": "Ajouter un congé",
    "for-me": "Pour moi-même",
    "for-another": "Pour un autre membre de l'équipe",
    "holiday-year-span": "Année de congé {{from}} - {{to}}",
    "booked": "Congé réservé",
    "add-more-leave": "Ajouter plus de congé",
    "leave-reporting": "Rapports de congé",
    "days-booked": "Jours réservés",
    "days-left": "Jours restants",
    "view-holidays": "Voir les congés",
    "allowance": "Quota : {{number}} jours",
    "insufficient-access-title": "Accès administrateur requis",
    "insufficient-access-description": "Pour accéder aux données et aux rapports, contactez votre gestionnaire ou administrateur pour demander les permissions nécessaires.",
    "holiday-tracking-disabled-title": "Suivi des congés inactif",
    "holiday-tracking-disabled-description": "Vous pouvez activer le suivi des congés pour les gestionnaires dans la zone des paramètres principaux.",
    "carried-over": "Reporté : {{number}} jours"
  },
  "upgrade": "Mettre à niveau",
  "change-pricing-plan": "Changer votre plan tarifaire",
  "get-in-touch": "Nous contacter",
  "company": "Entreprise",
  "help": "Aide",
  "faqs": "FAQ",
  "copyright": "Copyright © 2026 Team Today. Tous droits réservés.",
  "create-new-team": "Créer une nouvelle équipe ?",
  "user-view": "Vue utilisateur",
  "User": "Utilisateur",
  "Email": "E-mail",
  "Team name": "Nom de l'équipe",
  "Permissions": "Permissions",
  "tag-manager": "Gestionnaire de groupes de travail",
  "Back": "Retour",
  "back-to-company-view": "Retour à la vue d'entreprise",
  "users": "utilisateurs",
  "team members": "membres de l'équipe",
  "members": "Membres",
  "Add a team member": "Ajouter un membre d'équipe",
  "Invite a user": "Inviter un utilisateur",
  "Add existing user": "Ajouter un utilisateur existant",
  "Select a team": "Sélectionner une équipe",
  "Search results": "Résultats de recherche",
  "days": "jours",
  "choose-office-to-view": "Choisir un bureau à afficher",
  "create-an-office": "Créer un bureau",
  "create-an-office-description": "Définissez une limite au nombre de bureaux disponibles pour que les collègues sachent quand venir au bureau.",
  "office-space-bookings": "Réservations d'espace de bureau",
  "office-space-no-bookings": "Aucune réservation",
  "select-team-to-add-user-to": "Sélectionner une équipe à ajouter",
  "team-admins-limitation": "Les administrateurs d'équipe ne peuvent déplacer des utilisateurs que dans leur propre équipe",
  "search-for-existing-user": "Rechercher un utilisateur existant",
  "tag-view": "Vue de groupe",
  "Select...": "Sélectionner...",
  "did-you-know": "Le saviez-vous ?",
  "desk-reservation": "Réservation de bureau",
  "desk": "Bureau",
  "added-to-favourites": "Ajouté à vos favoris",
  "add-to-your-favourites": "Ajouter à vos favoris",
  "favouring-an-office-tip": "Favoriser un bureau le rend plus rapide à sélectionner lors de la définition de vos déplacements pour la semaine.",
  "back-to-whereabouts": "Retour aux déplacements",
  "404-error": "Désolé, 404. Non trouvé",
  "admin-access-required": "Accès administrateur requis",
  "insufficient-rights": "Droits d'accès insuffisants",
  "onboarding": {
    "add-user": {
      "title": "Ajouter un membre d'équipe",
      "message": "Ajoutez jusqu'à 10 personnes à cette équipe"
    },
    "create-an-office": "Créer un bureau",
    "create-team": "Créons votre première équipe pour votre entreprise...",
    "create-team-description": "Vous pouvez créer autant d'équipes que vous le souhaitez plus tard",
    "welcome-for-company": "Bienvenue sur le compte Team Today pour",
    "welcome": "Bienvenue sur Team Today",
    "welcome-message": "Planifiez vos déplacements pour la semaine de travail, réservez des bureaux, gérez les espaces de bureau et synchronisez tout avec vos calendriers professionnels.",
    "welcome-to-existing-company": "Commencez simplement par définir vos déplacements pour la semaine prochaine. Cela informera le reste de votre équipe de vos plans... c'est aussi simple que cela.",
    "choose-features": "Choisissez vos fonctionnalités",
    "choose-features-description": "Vous pouvez en avoir aussi peu ou autant que vous le souhaitez. Les paramètres peuvent être modifiés à tout moment dans le futur.",
    "whereabouts-feature": "Déplacements",
    "whereabouts-feature-description": "Une interface simple qui permet à tout le monde de savoir où chacun se trouve chaque semaine.",
    "deskbooking-feature": "Réservation de bureau et parking",
    "deskbooking-feature-description": "Gardez une trace des espaces de bureau et voyez combien de bureaux sont disponibles. Réservez même une place de parking.",
    "holiday-management-feature": "Gestion des congés",
    "holiday-management-feature-description": "Ajoutez des responsables hiérarchiques et autorisez les congés via Team Today.",
    "office-created-title": "Bureau créé",
    "office-created-message": "Vous pouvez visiter les paramètres plus tard pour créer plusieurs bureaux, étages, zones et ajouter un plan d'étage interactif pour que les collègues puissent réserver.",
    "team-required": "équipe requise",
    "create-office-reasoning": "Vous pouvez créer plusieurs bureaux pour que les membres de l'équipe puissent visiter.",
    "holiday-management": "Gestion des congés",
    "holiday-management-description": "Permettez aux membres de l'équipe de suivre les jours restants et de les partager avec l'équipe élargie.",
    "holiday-management-default-number": "Nombre de congés par défaut",
    "holiday-management-tip": "Vous pouvez définir des quotas de congés individuels et une date de renouvellement dans les paramètres",
    "custom-whereabouts-title": "Créez des déplacements et des emplacements de travail personnalisés facilement",
    "custom-whereabouts-description": "Visitez la zone des paramètres / gestion dans Team Today pour créer des déplacements personnalisés tels que chantier, formation ou visite client et les synchroniser automatiquement avec vos calendriers de messagerie.",
    "icons-title": "Choisissez votre style d'icônes",
    "icons-description": "Choisissez le style qui convient le mieux à votre entreprise",
    "icons-detailed": "Icônes détaillées",
    "icons-simple": "Icônes simples",
    "onboarding-complete": "Tout est configuré...",
    "onboarding-complete-description": "N'oubliez pas que vous pouvez télécharger l'application Team Today depuis le magasin Microsoft Teams et vous connecter.",
    "add-to-ms-teams": "Ajouter à Microsoft Teams",
    "required": "REQUIS"
  },
  "dialog-headers": {
    "sync-to-outlook": "Pour la meilleure expérience, synchronisez Team Today avec votre calendrier Outlook",
    "cannot-be-deleted": "Cela ne peut pas être supprimé",
    "are-you-sure": "Êtes-vous sûr ?",
    "update-desk": "Mettre à jour le bureau",
    "edit-tags": "Modifier les groupes de travail",
    "add-group-member": "Ajouter un membre de groupe",
    "manage-favourites": "Gérer les favoris",
    "filter-selection": "Sélection de filtre",
    "whereabouts-have-been-edited": "Vos déplacements ont été modifiés",
    "team-created": "Équipe créée",
    "choose-area": "Choisir une zone",
    "choose-floor": "Choisir un étage",
    "choose-office": "Choisir un bureau",
    "add-custom-whereabouts": "Ajouter des déplacements personnalisés",
    "company-created": "Entreprise créée",
    "payment-failed": "Paiement échoué",
    "payment-successful": "Paiement réussi",
    "select-line-reports": "Sélectionner les rapports hiérarchiques"
  },
  "payments": {
    "users-available-message": "Vous pouvez ajouter {{remainingUsers}} autres collègues à ce compte.",
    "upgrade-account-in-settings": "Mettez à niveau votre compte dans les paramètres",
    "with-as-many-users": "Avec un compte payant, vous pouvez ajouter autant d'utilisateurs que vous le souhaitez.",
    "how-many-users-you-need": "Combien d'utilisateurs avez-vous besoin ?",
    "manage-total-users": "Gérer le total des utilisateurs",
    "payment-method": "Mode de paiement",
    "card-payment": "Paiement par carte",
    "bank-transfer": "Virement bancaire",
    "bank-transfer-contact": "Pour gérer votre forfait par virement bancaire, contactez <0>hello@team-today.com</0> avec les détails de votre entreprise",
    "bank-transfer-annual-only": "Forfaits annuels uniquement",
    "bank-transfer-currencies": "Pour les virements bancaires, nous n'acceptons que le GBP et l'euro",
    "bank-transfer-po": "Nous acceptons les bons de commande",
    "how-often-you-pay": "Fréquence de paiement",
    "currency": "Devise",
    "first-10-users": "Premiers 10 utilisateurs",
    "FREE": "GRATUIT",
    "total-paid-users": "Total des utilisateurs payants",
    "monthly-amount": "Montant mensuel à payer",
    "year-amount": "Montant annuel à payer",
    "looking-to-cancel": "Vous souhaitez annuler ?",
    "looking-to-cancel-message": "Nous serions désolés de vous voir partir, mais vous pouvez annuler votre abonnement à tout moment en envoyant un e-mail à <0>hello@team-today.com</0>",
    "free-trial-ends": "Essai gratuit se termine",
    "view-payment-plan": "Voir votre plan de paiement",
    "choose-plan": "Choisissez votre forfait",
    "standard": "Standard",
    "free-plan": "Forfait gratuit",
    "professional-plan": "Forfait Professional",
    "premium-plan": "Forfait Premium",
    "enterprise-plan": "Forfait Enterprise",
    "professional": "Professional",
    "premium": "Premium",
    "enterprise": "Enterprise",
    "professional-features": "Jusqu'à 6 emplacements personnalisés",
    "premium-features": "Réservation de visiteurs et jusqu'à 32 emplacements personnalisés",
    "enterprise-features": "Gestionnaire de compte dédié et accompagnement à la mise en route",
    "your-plan": "Gérer votre forfait",
    "manage-subscription": "Mettre à jour l'abonnement",
    "manage-subscription-title": "Votre abonnement",
    "nav-your-plan": "Votre forfait",
    "nav-invoices": "Factures",
    "current-plan": "Forfait actuel",
    "looking-to-upgrade": "Envie de passer à une offre supérieure ?",
    "contact-us": "Contactez-nous",
    "upgrade-plan": "Améliorer le forfait",
    "upgrade-contact-title": "Mettre à niveau ou modifier votre abonnement",
    "manage-plan-title": "Gérer votre forfait",
    "manage-plan-body": "Pour ajuster votre nombre de licences ou changer votre forfait d'abonnement, veuillez nous contacter à <0>hello@team-today.com</0>. Nous mettrons à jour les détails de votre compte et gérerons pour vous les ajustements de facturation au prorata.",
    "enterprise-contact-body": "Pour passer à notre forfait Enterprise, veuillez nous contacter à <0>hello@team-today.com</0> pour parler à un responsable de compte.",
    "your-payment-plan": "Votre plan de paiement",
    "plan-pill": "Forfait {{plan}}",
    "monthly-plan": "Forfait mensuel",
    "annual-plan": "Forfait annuel",
    "total-licences": "Licences au total : {{licences}}",
    "plan-cost-summary-monthly": "{{cost}} / mois - Facturé mensuellement",
    "plan-cost-summary-yearly": "{{cost}} / an - Facturé annuellement",
    "next-renewal": "Prochain renouvellement : {{date}}",
    "custom-whereabouts-count": "{{number}} x Emplacements personnalisés",
    "unlock-more-premium": "débloquez-en plus avec Premium",
    "meeting-rooms-count": "{{number}} x Salles de réunion",
    "professional-custom-whereabouts": "32 x Emplacements personnalisés",
    "professional-meeting-rooms": "24 x Salles de réunion",
    "advanced-reporting": "Rapports avancés",
    "priority-support": "Support prioritaire",
    "interactive-floor-plans": "Plans d'étage interactifs",
    "car-parking": "Stationnement",
    "free-trial": "Essai gratuit",
    "change-plan-hint": "Le changement de forfait prend effet immédiatement ; votre prochaine facture sera calculée au prorata.",
    "confirm-plan-change": "Changer votre forfait d'abonnement maintenant ? Votre prochaine facture sera calculée au prorata.",
    "confirm-plan-change-title": "Changer de forfait",
    "confirm-plan-change-button": "Confirmer le changement",
    "plan-changed": "Votre forfait a été mis à jour",
    "plan-change-failed": "Nous n'avons pas pu changer votre forfait, veuillez contacter hello@team-today.com",
    "downgrade-contact-support": "Pour rétrograder votre forfait, veuillez contacter <0>support@team-today.com</0>",
    "manage-seats": "Gérer le total des licences",
    "seats-in-use": "{{used}} sur {{total}} places utilisateur payantes utilisées",
    "licences-in-use": "{{used}} sur {{total}} licences actuellement utilisées",
    "price-per-licence": "Prix par licence",
    "licences": "Licences",
    "total": "Total",
    "period-month": "mois",
    "period-year": "an",
    "update-seats": "Mettre à jour les places",
    "seats-change-hint": "La modification de vos places payantes prend effet immédiatement ; votre prochaine facture sera calculée au prorata.",
    "seats-updated": "Vos places payantes ont été mises à jour",
    "seats-update-failed": "Nous n'avons pas pu mettre à jour vos places payantes, veuillez contacter hello@team-today.com",
    "update-licenses": "Mettre à jour l'abonnement",
    "licenses-updated": "Vos licences ont été mises à jour",
    "licenses-update-failed": "Nous n'avons pas pu mettre à jour vos licences, veuillez contacter hello@team-today.com",
    "past-invoices": "Factures passées",
    "view-invoice": "Voir",
    "no-invoices": "Aucune facture passée pour le moment",
    "invoices-load-failed": "Nous n'avons pas pu charger vos factures pour le moment",
    "invoice-date": "Date",
    "invoice-amount": "Montant",
    "invoice-status": "Statut"
  },
  "team": {
    "empty-team-title": "Aucun membre dans cette équipe",
    "empty-team-description": "Ne vous inquiétez pas, vous pouvez y ajouter des personnes",
    "team-member-invited": "Membre d'équipe invité",
    "add-more-users-message": "Vous pouvez ajouter plus de collègues maintenant ou plus tard via l'application",
    "add-more-users-message-with-limit": "Vous pouvez ajouter <0>{remainingUsers} autres</0> collègues à votre <1>compte gratuit</1>",
    "remaining-users": "{{remainingUsers}} autres",
    "free-account": "compte gratuit",
    "paid-account-upsell": "Avec un compte payant, vous pouvez ajouter autant d'utilisateurs que vous le souhaitez. Configurez un essai GRATUIT de 30 jours en envoyant un e-mail à : hello@team-today.com.",
    "upgrade-link": "Ou mettez à niveau votre compte dans les paramètres",
    "restricted-team-title": "Cette équipe est privée",
    "restricted-team-description": "Pour accéder à cette équipe, demandez à un administrateur de vous y ajouter."
  },
  "whereabouts": {
    "select-floor": "Sélectionner un étage",
    "select-floor-description": "Sélectionnez un étage pour voir le bureau et réserver votre bureau.",
    "looking-after-multiple-teams": "Vous gérez plusieurs équipes ?",
    "create-company-view": "Créez une vue d'entreprise pour voir toutes vos équipes en un seul endroit",
    "custom-whereabouts": "Déplacements personnalisés",
    "add-custom-whereabouts": "Ajouter des déplacements personnalisés",
    "whereabouts-set-for-this-week": "Déplacements définis pour cette semaine",
    "all-done": "Terminé",
    "available-areas": "Zones disponibles",
    "available-desks": "Choisir un bureau via le menu déroulant",
    "seats-available": "{{remaining}} places disponibles",
    "add-favourite": "Ajouter aux favoris",
    "favouriting-suggestion-title": "Changez de bureau régulièrement ?",
    "favouriting-suggestion-description": "Favoriser un bureau le rend plus rapide à sélectionner lors de la définition de vos déplacements pour la semaine.",
    "no-offices": "Aucun bureau !",
    "no-offices-description": "Ajoutez un ou plusieurs bureaux dans les paramètres pour utiliser pleinement cette fonctionnalité.",
    "add-office-button": "Ajouter un bureau",
    "num-of-group-members": "{{count}} membres du groupe",
    "desks-available": "Bureaux disponibles",
    "parking-available": "Parking disponible",
    "no-available": "Aucun parking",
    "require-parking-space": "Exiger une place de parking",
    "require-weekly-schedule": "Répéter la planification hebdomadaire",
    "parking": "Parking",
    "car-park-bookings": "Réservations de parking",
    "car-park-capacity-and-usage": "{{spaces}} Places - {{bookings}} Réservations",
    "select-on-floor-plan": "Choisir un bureau sur le plan d'étage",
    "repeat-schedule": {
      "title": "Répéter la planification hebdomadaire",
      "alternate-weeks": "Alterner",
      "repeat-schedule-for": "Répéter chaque semaine pendant",
      "weeks": "semaines",
      "confirm-schedule": "Confirmer la planification",
      "cancel": "Annuler",
      "close": "Fermer",
      "cannot-be-done-setting-not-set": "Cette fonctionnalité ne peut pas être utilisée. Demandez à un administrateur d'entreprise d'aller dans les paramètres de l'entreprise pour configurer le nombre de semaines que vous pouvez définir."
    }
  },
  "office-checkin-page": {
    "title": "Merci",
    "confirmed": "C'est confirmé.",
    "login-message": "Vous pouvez maintenant vous connecter pour voir vos déplacements ou ceux de vos collègues."
  },
  "delete-team-dialog": {
    "title": "Supprimer l'équipe",
    "description": "Êtes-vous sûr de vouloir supprimer cette équipe ?",
    "warning-message": "Les utilisateurs pourront toujours se connecter mais ne seront pas assignés à une équipe"
  },
  "sync-to-outlook-dialog": {
    "yes": "Oui, synchroniser avec Outlook",
    "no": "Peut-être plus tard",
    "message": "Vous pouvez toujours configurer cela plus tard en visitant les paramètres et en modifiant vos préférences personnelles."
  },
  "whereabouts-changed-dialog": {
    "accept-message": "Pour accepter les modifications, appuyez simplement sur le bouton accepter les modifications et synchronisez-les avec votre calendrier.",
    "accept-with-no-outlook-sync-1": "Pour accepter les modifications, appuyez simplement sur le bouton accepter les modifications.",
    "accept-with-no-outlook-sync-2": "Vous pouvez les synchroniser avec votre compte Microsoft 365 ou Google en activant l'option dans les Paramètres.",
    "accept-and-sync": "Accepter les modifications et synchroniser avec le calendrier",
    "accept": "Accepter les modifications"
  },
  "delete-desk-dialog": {
    "message": "La suppression du bureau supprimera les éléments suivants :",
    "a-desk": "1 bureau",
    "bookings": "{{count}} réservation(s) de déplacement",
    "cannot-be-deleted": "Ce bureau appartient à un étage qui a un plan d'étage configuré, veuillez nous contacter à <a href=\"mailto: support@team-today.com\">support@team-today.com</a> si vous souhaitez le supprimer."
  },
  "delete-office-dialog": {
    "message": "La suppression du bureau supprimera les éléments suivants :",
    "office": "{{count}} bureau(x)",
    "floor": "{{count}} étage(s)",
    "area": "{{count}} zone(s)",
    "desk": "{{count}} bureau(x)",
    "favourites": "{{count}} favori(s)",
    "cannot-be-deleted-message": "Ce bureau contient un étage, veuillez nous contacter à <0 href=\"mailto: support@team-today.com\">support@team-today.com</0> si vous souhaitez le supprimer."
  },
  "delete-user-dialog": {
    "description": "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    "title": "Avertissement"
  },
  "calendar": {
    "mon": "L",
    "tue": "M",
    "wed": "M",
    "thur": "J",
    "fri": "V",
    "sat": "S",
    "sun": "D",
    "choose-week": "Choisir une semaine à afficher"
  },
  "ms-ad-sync": {
    "read-all-message-1": "Cette fonctionnalité nécessite des permissions différentes, elle ne sera utilisée que sur votre ordinateur et aucune information sensible ne sera envoyée à nos serveurs.",
    "read-all-message-2": "Cliquez ici pour demander des permissions à Microsoft",
    "message-1": "Voici une liste de tous les utilisateurs de votre compte Microsoft mais pas dans Team Today.",
    "message-2": "Vous pouvez rapidement faire défiler vers le bas et inviter les personnes que vous souhaitez avoir accès à Team Today.",
    "message-3": "Après les avoir invités, vous devrez les ajouter à une équipe ou ils pourront s'ajouter eux-mêmes à une équipe lors de leur inscription."
  },
  "room-finder": {
    "title": "Localisateur de salle",
    "no-selection": "Aucune salle de réunion ajoutée",
    "no-meeting-rooms-in-office": "Aucune salle de réunion dans ce bureau",
    "no-meeting-bookings": "Vous n'avez aucune réservation de salle de réunion à afficher.",
    "navigation": {
      "room-finder": "Localisateur de salle",
      "bookings": "Mes réservations",
      "open-search-panel": "Afficher les filtres",
      "filters": "Filtres"
    },
    "number-of-people": {
      "title": "Nombre de personnes",
      "any": "Tout",
      "1to2": "1 - 2",
      "3to5": "3 - 5",
      "6to8": "6 - 8",
      "8orMore": "8+"
    },
    "facilities": {
      "title": "Équipements",
      "tv": "TV",
      "conference-call": "Conférence téléphonique",
      "whiteboard": "Tableau blanc",
      "charge-points": "Points de charge"
    },
    "floor-filter": {
      "title": "Étage",
      "all-floors": "Tous les étages"
    }
  },
  "room-booking-dialog": {
    "add-to-calendar": "Ajouter au calendrier",
    "edit-booking-title": "Modifier la réservation",
    "title": "Réserver une salle de réunion",
    "meeting-title": "Entrez le titre de la réunion",
    "confirm-booking": "Confirmer la réservation",
    "cancel-booking": "Annuler la réservation",
    "save-changes": "Enregistrer les modifications",
    "no-booker-name": "Réservation Outlook",
    "cannot-book-outlook-room": "Vous ne pouvez pas réserver cette salle de réunion",
    "cannot-book-outlook-room-description": "Assurez-vous d'abord que votre synchronisation de calendrier est active pour que nous puissions réserver la salle à l'échelle du système.",
    "booked-in-outlook-title": "Cette réunion a été réservée via Outlook.",
    "booked-in-outlook-description": "Pour apporter des modifications à cette réservation, veuillez vous rendre dans votre calendrier Outlook.",
    "is-teams-meeting": "Réunion Teams",
    "outlook-booked-meeting": "Cette réunion a été réservée via Outlook, vous pouvez la mettre à jour ici mais les modifications peuvent ne pas être reflétées dans Outlook.",
    "notes": "Notes (définies dans Team Today)",
    "update-booking": "Mettre à jour la réservation",
    "cancel-series": "Annuler la série",
    "apply-to-series": "Appliquer les modifications à toutes les réunions futures de cette série",
    "outlook-link": "Lien Outlook",
    "can-not-update-outlook-meeting": "Impossible de mettre à jour les détails de la réunion Outlook",
    "recurrence": "Récurrence",
    "no-recurrence": "Pas de récurrence",
    "daily": "Quotidien",
    "weekly": "Hebdomadaire",
    "monthly": "Mensuel",
    "yearly": "Annuel",
    "for": "Pour",
    "frequency-day": "jour(s)",
    "frequency-week": "semaine(s)",
    "frequency-month": "mois",
    "frequency-year": "année(s)",
    "recurrence-summary": "Se produit {{frequency}} le {{dayName}}, se termine le {{endDate}}.",
    "recurrence-summary-single": "Se produit {{frequency}} le {{dayName}}.",
    "recurrence-summary-monthly": "Se produit mensuellement le {{dayOfMonth}}, se termine le {{endDate}}.",
    "recurrence-summary-monthly-single": "Se produit mensuellement le {{dayOfMonth}}.",
    "recurrence-summary-daily": "Se produit chaque jour ouvrable (lun-ven), se termine le {{endDate}}.",
    "recurrence-summary-daily-single": "Se produit chaque jour ouvrable (lun-ven).",
    "or-until": "Jusqu'au"
  },
  "delete-meeting-room-dialog": {
    "delete-meeting-room": "Supprimer la salle de réunion",
    "confirm-delete-meeting-room": "Oui, supprimer cette salle de réunion",
    "capacity": "Environ {{capacity}} personnes",
    "cancel": "Non, garder cette salle de réunion"
  },
  "reset-desks-dialog": {
    "reset-desks": "Réinitialiser les bureaux sélectionnés",
    "reset-all-desks": "Vous allez réinitialiser l'allocation de {{count}} bureaux",
    "cancel": "Annuler"
  },
  "link-group-to-office-dialog": {
    "title": "Lier une équipe ou un groupe de travail à un bureau",
    "office-label": "Sélectionnez les bureaux",
    "link-button": "Lier les bureaux",
    "clear-button": "Effacer les bureaux des groupes"
  },
  "new-user-onboarding-dialog": {
    "title": "Bienvenue sur Team Today",
    "done": "Terminé",
    "intro": "Vous pouvez rapidement vous configurer en complétant ces deux étapes.",
    "next": "Suivant",
    "office-label": "Sélectionnez les bureaux"
  },
  "manage-desks-sidebar": {
    "edit-view": "Modifier la vue",
    "desk-allocation": "Attribution des bureaux",
    "edit-desk": "Modifier le bureau",
    "desk-editor": "Éditeur de bureaux",
    "area-name": "Nom de la zone",
    "changed-desks-count": "{{count}} bureau modifié",
    "changed-desks-count_plural": "{{count}} bureaux modifiés",
    "save-desk-changes": "Enregistrer les modifications des bureaux",
    "total-desks": "{{total}} Bureaux au total",
    "selected-desks": "{{selected}} Bureaux sélectionnés",
    "select-all-desks": "Sélectionner tous les bureaux",
    "assign-to-indi": "Assigner à un individu",
    "assign-to-team": "Assigner à une équipe",
    "assign-to-workgroup": "Assigner à un groupe de travail",
    "reset-desks": "Réinitialiser les bureaux sélectionnés",
    "assign-desks-to-team": "Assigner des bureaux à une équipe",
    "assign-desks-to-individual": "Assigner des bureaux à un individu",
    "assign-desks-to-workgroup": "Assigner des bureaux à un groupe de travail",
    "active": "Actif"
  },
  "edit-team": {
    "select-office-description": "Sélectionnez les bureaux associés à cette équipe",
    "select-departments-description": "Sélectionnez les départements associés à cette équipe",
    "title": "Modifier l'équipe",
    "team-name": "Nom de l'équipe"
  },
  "team-and-group-radio-button-list": {
    "filter-desks": "Filtrer les bureaux par équipes et groupes de travail",
    "show-all": "Afficher tout"
  },
  "manage-tag-dialog": {
    "delete": "Supprimer le groupe de travail",
    "update": "Mettre à jour le groupe de travail",
    "group-summary": "Il y a {{count}} utilisateurs dans ce groupe de travail",
    "edit-title": "Modifier un groupe de travail",
    "create-title": "Créer un groupe de travail"
  },
  "manage": {
    "add-new-user": {
      "title": "Ajouter un membre d'équipe",
      "subtitle": "Invitez jusqu'à {{count}} collègues sur ce compte",
      "invite-new-user": "Inviter un nouvel utilisateur",
      "add-existing-user": "Ajouter un utilisateur existant",
      "required": "Requis",
      "account": "Compte",
      "free": "Compte gratuit",
      "premium": "Compte premium",
      "trial": "Compte d'essai",
      "enterprise": "Compte entreprise",
      "total": "Licences totales",
      "current": "Utilisateurs actuels",
      "remaining": "Places restantes",
      "team-member-added": "Membre d'équipe ajouté",
      "user-already-in-account": "Ce compte existe déjà.\nAllez dans Paramètres > <0>Gérer les utilisateurs</0> pour l'affecter à la bonne équipe.",
      "user-deleted": "Ce compte existe déjà.\nCet utilisateur a été supprimé. Vous pouvez rétablir son accès dans Paramètres > Gérer les utilisateurs > <0>Utilisateurs supprimés</0>.",
      "paid-account-promote": "Avec un compte payant, vous pouvez ajouter autant d'utilisateurs que vous le souhaitez. Configurez un essai GRATUIT de 30 jours en envoyant un e-mail à : hello@team-today.com",
      "upgrade": "Ou mettez à niveau votre compte dans les paramètres"
    }
  },
  "header": {
    "meeting-rooms": "Salles de réunion",
    "leave-planner": "Planificateur de congés",
    "reports": "Rapports",
    "view-my-bookings": "Voir mes réservations",
    "hospitality": "Hospitalité"
  },
  "floor-plan-editor": {
    "open-editor": "Modifier le plan d'étage (Bêta)",
    "add-desk": "Ajouter un bureau",
    "add-area": "Ajouter une zone",
    "save": "Enregistrer",
    "selected": "{{label}} sélectionné",
    "rename-desk": "Renommer le bureau",
    "clone-desk": "Dupliquer le bureau",
    "keyboard-hint": "WASD pour déplacer, Q et E pour pivoter, C pour dupliquer",
    "delete-desk": "Supprimer le bureau",
    "desk-portrait": "Bureau P ({{width}}, {{height}})",
    "desk-landscape": "Bureau L ({{width}}, {{height}})",
    "corner-desk-portrait": "Bureau d'angle P ({{width}}, {{height}})",
    "corner-desk-landscape": "Bureau d'angle L ({{width}}, {{height}})",
    "rotate-left": "Pivoter de {{degrees}}° à gauche",
    "rotate-right": "Pivoter de {{degrees}}° à droite",
    "new-area": "Nouvelle zone",
    "no-desks-warning": "Vous devez d'abord ajouter au moins un bureau via le panneau de configuration",
    "unsaved-changes": "Vous avez des modifications de plan non enregistrées. Voulez-vous vraiment quitter ?",
    "save-success": "Modifications du plan enregistrées",
    "save-failed": "Échec de l'enregistrement des modifications du plan",
    "area-create-failed": "Échec de la création de la zone",
    "no-floor-plan": "Ce bureau n'a pas de plan d'étage interactif."
  },
  "office-map": {
    "select-office": "Sélectionner un bureau"
  },
  "desk-booking": {
    "confirm-booking": "Confirmer la réservation",
    "edit-parking": "Modifier le parking",
    "no-space-selected": "Aucun espace sélectionné"
  },
  "car-parking": {
    "label": "Étiquette",
    "yaxis": "Axe Y",
    "width": "Largeur",
    "height": "Hauteur",
    "rotation": "Rotation",
    "xaxis": "Axe X",
    "edit-space-title": "Modifier la place de parking",
    "cancel-booking": "Annuler la réservation",
    "am-cancel-booking": "Annuler matin",
    "pm-cancel-booking": "Annuler après-midi",
    "are-you-sure-delete": "Êtes-vous sûr de vouloir supprimer cette place de parking ?"
  },
  "visitor-booking": {
    "daily-visitors": "Visiteurs du bureau",
    "filter": "Filtrer les visiteurs",
    "visitors-in-today": "{{count}} Visiteurs aujourd'hui",
    "manage-visitors": "Gérer les visiteurs",
    "visitor-office-title": "Visiteurs - bureau {{officeName}}",
    "add-visitor": "Ajouter un visiteur",
    "edit-visitor": "Modifier un visiteur",
    "cancel": "Supprimer le visiteur",
    "visitor-name": "Nom du visiteur",
    "company-name": "Nom de l'entreprise",
    "due-in": "Dû dans",
    "meeting-with": "Réunion avec",
    "due-today": "Dû aujourd'hui",
    "signed-in": "Connecté",
    "signed-out": "Déconnecté",
    "no-visitors-today": "Aucun visiteur aujourd'hui",
    "repeat-booking": "Répéter la réservation",
    "cancel-desk": "Annuler le bureau",
    "book-desk": "Réserver un bureau",
    "sign-in": "Se connecter",
    "sign-out": "Se déconnecter",
    "meeting-room-label": "Salle de réunion : {{room}}",
    "meeting-room-label-with-time": "Salle de réunion : {{room}}, de {{from}} à {{to}}"
  },
  "department-dialog": {
    "title": "Modifier le département",
    "name": "Nom",
    "users": "Nombre d'utilisateurs dans le département"
  },
  "allowance": {
    "title": "Quota de congés",
    "basic": "Quota de base",
    "additional": "+ Jours supplémentaires",
    "total": "Total",
    "used": "Utilisé",
    "remaining": "Restant",
    "justDays": "Jours",
    "days": "{{days}} Jours",
    "breakdown-basic": "Quota de base",
    "breakdown-additional": "Jours supplémentaires",
    "breakdown-carried-over": "Reporté de l'année dernière",
    "breakdown-expires": "Expire le : {{date}}",
    "breakdown-total": "Quota total de congés",
    "breakdown-total-expiry-tooltip": "Le quota total inclut des jours susceptibles d'expirer",
    "expiry-report": "Rapport d'expiration des congés",
    "go-to-reporting": "Aller aux rapports",
    "carry-over": "Report",
    "go-to-rollover-management": "Aller au report de congés",
    "rollover": "Report",
    "confirm-dialog": {
      "title": "Êtes-vous sûr ?",
      "description-1": "Cela effectuera le report de congés pour toute l'entreprise. Les congés non utilisés de {{previousYear}} seront reportés en {{currentYear}}.",
      "description-2": "Vous ne pourrez pas relancer le report à l'échelle de l'entreprise pour cette année.",
      "description-3": "Vous pouvez mettre à jour le report d'un utilisateur et d'autres allocations via 'Modifier les allocations de congés individuelles'.",
      "continue": "Oui, reporter les congés",
      "cancel": "Non, je ne suis pas encore prêt"
    },
    "just-additional": "Supplémentaire",
    "current-carryover": "Report actuel",
    "updated": "Mis à jour",
    "projected-total": "Total prévu pour {{year}}",
    "unused-allowance": "Allocation non utilisée de {{year}}",
    "days-to-carry-over": "Jours à reporter en {{year}}`",
    "carried-over": "+ Reporté",
    "remaining-days": "Jours restants",
    "standard-remaining-days": "Jours standard restants",
    "total-days-booked": "Total des jours ouvrés réservés",
    "carry-over-remaining": "Report restant",
    "holiday-carry-over-has-been-run": "Le report automatique à l'échelle de l'entreprise a déjà été effectué pour cette année de congés.<br>Vous pouvez toujours modifier les allocations individuelles ou nous contacter pour relancer le report à l'échelle de l'entreprise.",
    "holiday-carry-over-info": {
      "info": "Le rapport de report de congés affiche un aperçu des jours reportés pour l'année prochaine. Appuyez sur <strong>Confirmer</strong> en bas de l'écran pour appliquer les allocations mises à jour pour tous les utilisateurs.",
      "expiry-info": "Le rapport d'expiration des congés affiche un aperçu des jours qui vont expirer. Appuyez sur <strong>Confirmer l'expiration</strong> en bas de l'écran pour appliquer les allocations mises à jour pour tous les utilisateurs.",
      "carry-over-left": "La limite maximale de report est de {{carryOverDays}} jours.",
      "leave-settings": "Pour ajuster cela, allez dans <0>Paramètres de congés</0>.",
      "carry-over-expires": "Le report expire le {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Le report n'expire pas",
      "view-report": "Voir le rapport",
      "carry-over-days-title-additional": "Inclut {{additionalDays}} jours supplémentaires.",
      "carry-over-days-title-carry": "Inclut {{carriedOverDays}} jours reportés.",
      "carry-over-days-explanation": "Pour ajuster cela, allez dans les allocations individuelles",
      "days-to-carry-over-column-alert-title": "Actuellement configuré pour reporter {{carryOverDays}} jours.",
      "days-to-carry-over-column-alert-explanation": "Si ces chiffres sont différents, des congés ont été ajoutés depuis la dernière exécution du rapport de report.",
      "carry-over-report-title": "Rapport de report de congés"
    },
    "holiday-expiry-info": {
      "carry-over-left": "La limite maximale de report est de {{carryOverDays}} jours.",
      "leave-settings": "Pour ajuster cela, allez dans <0>Paramètres de congés</0>.",
      "carry-over-expires": "Le report expire le {{carryOverExpiryDate}}",
      "carry-over-does-not-expire": "Le report n'expire pas",
      "view-report": "Voir le rapport",
      "carry-over-days-title": "Inclut {{additionalDays}} jours supplémentaires.",
      "carry-over-days-explanation": "Pour ajuster cela, allez dans les allocations individuelles"
    }
  },
  "leave-type-dialog": {
    "title": "Choisir le type de congé"
  },
  "languages": {
    "english": "Anglais",
    "french": "Français",
    "german": "Allemand",
    "spanish": "Espagnol"
  },
  "calendar-sync": {
    "turn-on": "Activer",
    "active": "Synchronisation du calendrier active",
    "loading": "Chargement de la synchronisation du calendrier",
    "none": "Aucune synchronisation du calendrier",
    "disabled": "Synchronisation du calendrier désactivée",
    "unknown": "Statut inconnu"
  },
  "whereabouts-labels": {
    "COMPANY_HOLIDAY": "Jour férié de l'entreprise",
    "HOLIDAY_REJECTED": "Congé (Rejeté)",
    "HOLIDAY_APPROVED": "Congé (Approuvé)",
    "NOT_WORKING": "Jour non travaillé",
    "UNKNOWN": "Inconnu",
    "HOLIDAY": "Congé",
    "HOLIDAY_PENDING": "Congé (En attente)",
    "HOME": "Télétravail",
    "OFFICE": "Au bureau"
  },
  "user-hover": {
    "add-favourites": "Ajouter aux favoris",
    "remove-favourites": "Retirer des favoris",
    "leave": "Voir les congés"
  },
  "hospitality": {
    "add-from-menu": "Ajouter des articles du menu",
    "add-instructions": "Ajouter des instructions",
    "add-special-items": "Ajouter des articles spéciaux",
    "confirm-instructions": "Confirmer les instructions",
    "instructions-title": "Ajouter des instructions",
    "instructions-description": "Ajouter des notes (par ex. préférences alimentaires)",
    "cost-center": "Centre de coûts",
    "choose-items": "Choisir des articles du menu",
    "confirm": "Confirmer les choix",
    "add-item": "Ajouter un article",
    "special-hospitality-item-title": "Ajouter un article d'hospitalité spécial",
    "food-cost": "Coût alimentaire (€)",
    "quantity": "Quantité",
    "delivery": "Livraison",
    "item": "Article",
    "total-cost": "Coût total",
    "no-items": "Aucun article n'a été ajouté à cette réunion.",
    "not-started": "Non commencé",
    "in-progress": "En cours",
    "done": "Terminé",
    "report-day": "Télécharger le rapport du jour.csv",
    "report-week": "Télécharger le rapport de la semaine.csv",
    "report-month": "Télécharger le rapport du mois.csv",
    "no-bookings": "Aucune réservation d'hospitalité",
    "no-bookings-description": "Ajoutez de l'hospitalité lors de la réservation d'une réunion",
    "add-visitor": {
      "title": "Ajouter un visiteur",
      "add-visitor": "Ajouter un visiteur",
      "company": "Nom de l'entreprise",
      "email": "Adresse e-mail (uniquement si envoi direct de l'invitation)",
      "due-in": "Attendu à",
      "meeting-with": "Réunion avec"
    }
  }
}
